/* eslint-disable react/prop-types */
import * as React from 'react';

function WealthboxIcon(props: any): React.JSX.Element {
  const marginTop = '-16px';
  const marginLeft = '-5px';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="79"
      viewBox="0 0 150 79"
      style={{ marginTop, marginLeft }}
    >
      <g>
        <path fill={props.fill || '#FEFEFE'} d="M0 0h150v79H0V0zm0 0"></path>
        <path
          fill="#FDFEFE"
          d="M22.148 23.996c.106.063.215.121.32.184.243.14.485.285.727.425.32.192.645.38.97.567.948.543 1.894 1.094 2.839 1.648.574.34 1.152.672 1.73 1.004.536.305 1.067.613 1.598.926.398.23.797.457 1.195.688.407.234.813.468 1.215.71.211.125.418.247.633.364.648.367 1.129.703 1.371 1.441.031.211.031.414.031.625v5.859c-.004.668 0 1.336 0 2.004V46.34c-.004.476-.117 1.031-.457 1.387-.265.218-.566.386-.863.558-.043.024-.086.05-.133.074-.254.149-.508.293-.761.442-.34.191-.676.39-1.012.59-.516.3-1.031.601-1.551.898-.512.293-1.023.59-1.531.887a285.51 285.51 0 01-3.149 1.828c-.484.277-.96.555-1.441.836-.445.265-.895.527-1.344.785-.047.027-.094.059-.144.086-1.036.598-1.036.598-1.48.605-.052 0-.106 0-.157.004-.438-.047-.813-.234-1.188-.453l-.136-.074c-.43-.25-.86-.5-1.29-.754-.46-.27-.921-.539-1.382-.8-.578-.333-1.153-.669-1.723-1.005a134.35 134.35 0 00-1.27-.734c-.39-.223-.773-.45-1.16-.676-.468-.277-.937-.547-1.41-.816-.418-.238-.836-.477-1.25-.723a30.961 30.961 0 00-.777-.453l-.102-.062a20.838 20.838 0 01-.5-.29c-1.386-.796-1.386-.796-1.593-1.55-.024-.211-.024-.414-.024-.625v-.188-.613c0-.149-.004-.293-.004-.441v-1.075-.87-.255-.125c-.004-.793-.004-1.582 0-2.37 0-.723-.004-1.446-.004-2.165-.003-.742-.003-1.484-.003-2.226v-1.25a58.99 58.99 0 010-1.176c0-.14 0-.285-.004-.43 0-.195 0-.39.003-.586-.003-.058-.003-.113-.003-.172.007-.508.183-.906.52-1.281.234-.215.495-.367.776-.516l.329-.187.171-.094c.297-.168.586-.34.88-.512.488-.289.976-.574 1.468-.855.387-.219.77-.445 1.152-.672.555-.324 1.114-.64 1.672-.957.356-.2.711-.402 1.059-.617.32-.195.648-.383.973-.567.648-.367 1.293-.742 1.933-1.12.309-.18.617-.364.926-.544.113-.066.223-.128.332-.195.055-.031.105-.062.16-.094.121-.07.238-.14.356-.21.093-.06.093-.06.191-.114.055-.035.113-.07.172-.105.726-.391 1.496-.121 2.144.273zm0 0"
        ></path>
        <path
          fill="#116ED4"
          d="M22.148 23.996c.106.063.215.121.32.184.243.14.485.285.727.425.32.192.645.38.97.567.948.543 1.894 1.094 2.839 1.648.574.34 1.152.672 1.73 1.004.536.305 1.067.613 1.598.926.398.23.797.457 1.195.688.407.234.813.468 1.215.71.211.125.418.247.633.364.648.367 1.129.703 1.371 1.441.031.211.031.414.031.625v5.859c-.004.668 0 1.336 0 2.004V46.34c-.004.476-.117 1.031-.457 1.387-.265.218-.566.386-.863.558-.043.024-.086.05-.133.074-.254.149-.508.293-.761.442-.34.191-.676.39-1.012.59-.516.3-1.031.601-1.551.898-.512.293-1.023.59-1.531.887a285.51 285.51 0 01-3.149 1.828c-.484.277-.96.555-1.441.836-.445.265-.895.527-1.344.785-.047.027-.094.059-.144.086-1.036.598-1.036.598-1.48.605-.052 0-.106 0-.157.004-.438-.047-.813-.234-1.188-.453l-.136-.074c-.43-.25-.86-.5-1.29-.754-.46-.27-.921-.539-1.382-.8-.578-.333-1.153-.669-1.723-1.005a134.35 134.35 0 00-1.27-.734c-.39-.223-.773-.45-1.16-.676-.468-.277-.937-.547-1.41-.816-.418-.238-.836-.477-1.25-.723a30.961 30.961 0 00-.777-.453l-.102-.062a20.838 20.838 0 01-.5-.29c-1.386-.796-1.386-.796-1.593-1.55-.024-.211-.024-.414-.024-.625v-.188-.613c0-.149-.004-.293-.004-.441v-1.075-.87-.255-.125c-.004-.793-.004-1.582 0-2.37 0-.723-.004-1.446-.004-2.165-.003-.742-.003-1.484-.003-2.226v-1.25a58.99 58.99 0 010-1.176c0-.14 0-.285-.004-.43 0-.195 0-.39.003-.586-.003-.058-.003-.113-.003-.172.007-.508.183-.906.52-1.281.234-.215.495-.367.776-.516l.329-.187.171-.094c.297-.168.586-.34.88-.512.488-.289.976-.574 1.468-.855.387-.219.77-.445 1.152-.672.555-.324 1.114-.64 1.672-.957.356-.2.711-.402 1.059-.617.32-.195.648-.383.973-.567.648-.367 1.293-.742 1.933-1.12.309-.18.617-.364.926-.544.113-.066.223-.128.332-.195.055-.031.105-.062.16-.094.121-.07.238-.14.356-.21.093-.06.093-.06.191-.114.055-.035.113-.07.172-.105.726-.391 1.496-.121 2.144.273zm-2.05 3.75c-.051.027-.102.059-.153.086-.164.098-.328.191-.492.29-.113.066-.223.132-.336.194-.234.137-.469.278-.703.414-.375.223-.75.442-1.129.66-.433.25-.863.5-1.293.755a95.48 95.48 0 01-1.613.93c-.52.288-1.035.585-1.543.894-.27.16-.54.316-.809.472-.054.032-.113.063-.168.094-.105.059-.21.117-.312.176-.453.258-.856.488-1.117.953a3.22 3.22 0 00-.032.477v4.433c.004.621 0 1.242 0 1.864V44.8c.004.316.09.562.266.832.133.12.133.12.3.207.048.027.048.027.095.058l.23.13c.16.09.32.183.48.277.649.379 1.301.754 1.95 1.125.39.222.777.449 1.164.68.64.374 1.289.745 1.933 1.117 1.16.664 1.16.664 1.711.992l.118.07c.261.152.52.309.78.469.102.062.204.125.305.183.102.063.2.121.297.184.504.3.504.3 1.067.285.21-.086.402-.191.597-.308l.168-.094.524-.305.164-.098c.27-.16.539-.32.805-.48.363-.219.734-.43 1.101-.64.336-.192.672-.387 1.008-.583.383-.222.766-.445 1.152-.664.438-.254.875-.508 1.309-.765.598-.352 1.195-.696 1.797-1.04l.386-.222.387-.223c.063-.035.125-.07.192-.11l.171-.093a.95.95 0 00.41-.547c.036-.199.032-.394.032-.593v-.141-.469c0-.113.004-.222.004-.336v-.91-.566c0-.594.004-1.184.004-1.778v-2.05c.004-.532.004-1.06.004-1.586v-.95-.89c0-.11 0-.219.003-.328v-.446-.129c-.003-.359-.093-.593-.347-.843-.258-.203-.55-.356-.836-.512-.121-.07-.246-.137-.367-.207-.059-.035-.117-.066-.18-.102-.227-.129-.45-.261-.672-.394-.36-.211-.719-.422-1.082-.63a146.41 146.41 0 01-1.324-.769c-.969-.57-1.938-1.136-2.918-1.687a78.081 78.081 0 01-1.742-1.024l-.196-.117c-.054-.035-.113-.066-.168-.101-.535-.313-.87-.239-1.382.066zm0 0"
        ></path>
        <path
          fill="#010101"
          d="M38.203 31.422h3.809a1835.324 1835.324 0 00.73 3.18c.149.625.29 1.25.426 1.875.2.89.402 1.777.613 2.664.024.101.051.207.074.312l.141.598.035.14c.02.086.04.172.063.262l.176.758a6.905 6.905 0 01.203 1.238h.117c.004-.113.004-.113.012-.226.035-.352.125-.68.218-1.02.102-.383.192-.766.27-1.152.117-.543.242-1.078.379-1.614.203-.8.394-1.605.574-2.414.14-.632.293-1.257.453-1.886.219-.883.418-1.766.613-2.657h3.575a57.575 57.575 0 01.406 1.582l.031.122c.055.222.11.441.168.66l.035.14.07.293c.083.317.165.637.243.957l.21.832c.555 2.192.555 2.192.77 3.172.082.367.172.727.266 1.09l.152.633c.012.043.02.086.031.129l.094.387c.02.086.043.175.063.265.054.215.105.43.156.649.121-.328.187-.664.258-1.008.011-.063.027-.125.039-.192.027-.136.054-.27.086-.406.07-.351.144-.7.218-1.05.012-.067.028-.137.043-.208.11-.527.227-1.054.352-1.582.121-.523.23-1.05.336-1.582.098-.468.2-.937.309-1.402.144-.617.273-1.234.398-1.852.113-.566.238-1.125.363-1.687h3.633c-.27 1.082-.27 1.082-.402 1.57l-.047.164c-.028.114-.059.227-.09.34-.121.434-.238.871-.36 1.309-.027.11-.058.218-.085.328-.176.633-.344 1.27-.5 1.906-.082.336-.172.672-.274 1-.215.73-.414 1.465-.613 2.203a6.565 6.565 0 00-.047.188c-.223.82-.437 1.648-.648 2.472-.125.493-.262.98-.407 1.47-.183.616-.343 1.241-.504 1.862-.019.063-.019.063-.035.13l-.086.335c-.074.274-.156.547-.238.82h-3.281c-.063-.261-.129-.523-.195-.789-.04-.167-.082-.335-.125-.503a58.095 58.095 0 00-.196-.79c-.297-1.218-.297-1.218-.625-2.43a16.3 16.3 0 01-.238-.98c-.027-.109-.05-.222-.074-.332-.02-.078-.02-.078-.035-.16a40.362 40.362 0 00-.383-1.504c-.242-.879-.457-1.761-.672-2.644a20.413 20.413 0 00-.113-.469c-.09-.379-.184-.754-.274-1.133-.074.219-.14.434-.195.656-.016.055-.027.11-.043.168-.016.063-.027.121-.043.184l-.047.187c-.18.735-.355 1.465-.523 2.2-.137.601-.274 1.203-.434 1.797-.082.304-.16.613-.234.918-.012.054-.028.109-.04.164-.109.425-.21.855-.312 1.285-.152.652-.309 1.3-.46 1.949l-.106.43c-.047.21-.098.422-.149.629l-.047.195c-.02.09-.02.09-.043.18l-.035.156c-.05.195-.105.387-.16.574h-3.223c-.285-.98-.57-1.969-.851-2.953a86.271 86.271 0 00-.504-1.715c-.082-.266-.152-.527-.227-.793-.191-.703-.39-1.398-.59-2.098-.015-.05-.027-.101-.042-.156l-.176-.61-.223-.788c-.144-.512-.293-1.024-.441-1.54-.211-.726-.418-1.456-.625-2.183-.192-.684-.387-1.371-.59-2.05-.11-.383-.203-.762-.3-1.15zm0 0"
        ></path>
        <path
          fill="#020202"
          d="M107.578 31.422h3.164c.02 1.848.04 3.7.059 5.601.176-.195.347-.386.527-.59.984-.87 2.145-1.136 3.422-1.07 1.188.082 2.176.469 3.008 1.352 1.164 1.375 1.449 3.14 1.445 4.894v.141c-.004.727-.05 1.41-.258 2.113-.011.047-.027.09-.039.137-.238.832-.574 1.555-1.133 2.223-.039.05-.039.05-.078.105-.578.742-1.601 1.313-2.52 1.465-1.284.148-2.53.09-3.612-.688-.29-.238-.555-.5-.82-.765l-.06 1.18h-1.296c-.149 0-.297.003-.446.003h-1.183c-.121-.003-.121-.003-.18-.066a5.345 5.345 0 01-.008-.254v-.172-.187-.2-.664-.472-1.024c.004-.496.004-.988.004-1.48v-2.402-2.332-.145-.719c0-1.996.004-3.988.004-5.984zm0 0"
        ></path>
        <path
          fill="#116ED4"
          d="M15.645 32.367l.058 10.024c1.055-.594 1.055-.594 2.094-1.207.418-.254.848-.496 1.27-.739.324-.183.648-.37.964-.566.074-.043.074-.043.153-.094.093-.055.187-.113.277-.172.043-.023.082-.05.125-.074l.105-.066c.204-.059.364.066.543.16l.149.086.164.093c.058.032.117.067.176.102.062.035.12.066.183.106.38.214.754.433 1.13.66.472.277.948.55 1.421.82.543.313 1.078.629 1.617.95V32.425c.211.086.395.168.594.281l.176.098c.062.035.12.07.187.105.063.04.125.074.192.113.465.262.925.528 1.386.793l.176.106c.086.047.086.047.168.098.047.027.098.054.145.085.047.028.093.06.14.09.051.032.102.063.153.098.14.137.14.137.175.32 0 .11 0 .11.004.223v3.851c-.004.54 0 1.079 0 1.618V43.98c-.004.075-.004.149-.004.223-.054.293-.23.418-.468.582-.047.028-.098.055-.145.082a8.899 8.899 0 01-.168.098c-.058.035-.12.066-.18.101-.125.075-.253.149-.378.22-.063.038-.13.073-.196.112-.324.188-.648.38-.972.567-.09.055-.09.055-.18.105-.055.035-.11.067-.168.102a6.92 6.92 0 00-.145.086c-.101.058-.199.117-.293.183-.14.075-.14.075-.304.043a7.6 7.6 0 01-.68-.367c-.047-.027-.094-.054-.144-.086-.106-.062-.207-.125-.313-.183-.281-.168-.562-.332-.84-.496-.09-.051-.09-.051-.18-.106-.574-.336-1.152-.672-1.73-1.008-.207-.117-.41-.238-.613-.36l-.117-.07-.286-.175c-.175-.078-.207-.067-.382-.008-.106.055-.207.11-.309.168l-.184.102c-.062.039-.125.074-.191.113-.066.035-.133.074-.203.113-.399.227-.793.457-1.188.691-.445.266-.894.528-1.347.786-.293.168-.586.34-.871.52-.047.027-.09.058-.137.085-.086.05-.168.106-.25.16-.258.16-.258.16-.442.125-.05-.031-.101-.058-.152-.09-.078-.043-.156-.082-.234-.125-.094-.05-.188-.105-.281-.156a56.12 56.12 0 01-1.574-.906c-.06-.035-.114-.066-.173-.102a5.817 5.817 0 00-.16-.093c-.191-.114-.386-.215-.582-.32-.101-.067-.101-.067-.219-.243-.015-.18-.015-.18-.019-.398v-.125c0-.137 0-.274-.004-.41v-.297c-.004-.32-.004-.645-.008-.965v-.332c-.004-.465-.004-.926-.004-1.387l-.011-1.984c-.004-.465-.008-.93-.008-1.399 0-.277 0-.554-.004-.832-.004-.261-.004-.523-.004-.785v-.285c-.016-.727-.016-.727.18-.973.133-.105.258-.187.41-.265.055-.032.11-.067.164-.098.047-.027.094-.05.14-.074.25-.133.497-.27.743-.41.05-.028.05-.028.101-.059.075-.04.145-.082.215-.121.106-.063.211-.125.32-.184.364-.21.727-.422 1.082-.644.106-.059.106-.059.165-.059zm0 0"
        ></path>
        <path
          fill="#010101"
          d="M125.938 35.355h.207a5.965 5.965 0 011.53.196c.04.008.075.02.118.027.86.227 1.621.61 2.285 1.211l.133.117c1.055.985 1.574 2.489 1.64 3.907.008.269.012.539.012.808v.145c-.004.789-.07 1.52-.32 2.273-.012.043-.027.082-.04.125-.273.836-.75 1.555-1.366 2.176-.04.039-.078.078-.117.12-.614.595-1.415.958-2.227 1.177l-.156.047c-.528.14-1.028.156-1.567.152h-.433c-1.496.004-2.89-.453-3.996-1.496-.633-.668-1.016-1.43-1.29-2.3-.015-.048-.035-.099-.05-.15-.403-1.171-.387-2.718-.125-3.917l.047-.23a5.645 5.645 0 011.476-2.778l.102-.113c1.027-1.11 2.687-1.504 4.136-1.497zm0 0M65.508 35.492l.18.035c1.156.262 2.14.891 2.789 1.895.98 1.574.957 3.086.957 4.969h-8.086c.117.941.273 1.886 1.047 2.511.71.453 1.566.551 2.382.395.559-.172.961-.457 1.258-.961l.176-.531h3.047c-.067.597-.067.597-.133.797-.012.043-.027.086-.04.128-.015.047-.03.09-.046.133a3.27 3.27 0 01-.05.145c-.356 1.023-1.032 1.812-2.005 2.289-.382.18-.77.305-1.183.398l-.114.032c-.484.117-.972.105-1.464.105-.157 0-.309 0-.465.004-1.574.004-2.965-.426-4.11-1.555-1.273-1.398-1.535-3.363-1.472-5.183.07-1.63.633-3.07 1.765-4.25.04-.043.079-.082.118-.125.613-.594 1.414-.953 2.226-1.172l.211-.059c.969-.219 2.043-.203 3.012 0zm0 0"
        ></path>
        <path
          fill="#020202"
          d="M79.492 36.21c.43.345.758.74 1.016 1.227l.07.13c.578 1.195.477 2.703.473 3.988-.004.207-.004.414-.004.625v3.909c-.004.231-.004.462-.004.688v.559c-.008.121-.008.121-.066.184-.09.003-.184.003-.278.003h-1.191c-.14-.003-.281-.003-.422-.003h-1.04l-.058-1.418c-.078.086-.16.171-.242.257-.902.907-1.96 1.41-3.254 1.422h-.215c-.109-.004-.109-.004-.222-.004-1.04-.015-1.965-.261-2.73-1.004-.723-.757-.977-1.644-.977-2.675.023-.977.394-1.735 1.078-2.418 1.633-1.524 4.469-1.532 6.562-1.473-.008-1.008-.008-1.008-.425-1.91-.508-.484-1.149-.527-1.82-.516-.536.024-1.044.13-1.434.528-.204.261-.32.523-.422.836a64.117 64.117 0 01-2.207-.176l-.664-.059c.015-.11.035-.222.05-.336.012-.058.02-.12.032-.187a3.43 3.43 0 01.27-.774c.019-.043.038-.09.062-.133.422-.835 1.183-1.43 2.047-1.753 1.832-.555 4.39-.707 6.015.484zm0 0"
        ></path>
        <path
          fill="#010101"
          d="M95.684 31.422h3.105v5.719h.117c.012-.032.028-.063.04-.098.421-.758 1.327-1.266 2.128-1.492l.18-.055c1.121-.289 2.387-.2 3.41.363.895.582 1.309 1.426 1.531 2.45.09.504.102.988.102 1.5v.933c-.004.238-.004.477-.004.715v2.895c0 1.054-.004 2.109-.004 3.168h-3.164c0-.235-.004-.47-.004-.711l-.012-2.325c-.004-.468-.007-.937-.007-1.41-.004-.406-.004-.816-.008-1.226-.004-.22-.004-.434-.004-.649 0-.242-.004-.488-.004-.73v-.215c-.008-.645-.031-1.336-.496-1.828-.606-.375-1.211-.426-1.91-.305-.555.149-1.094.488-1.399.977-.035.05-.066.105-.101.156-.254.488-.301.922-.297 1.465 0 .074-.004.144-.004.222v.594c0 .207-.004.418-.004.625 0 .395-.004.79-.004 1.18-.004.707-.004 1.414-.008 2.12-.004.247-.004.497-.004.743 0 .192 0 .379-.004.57V47.336c-.007.121-.007.121-.066.184h-3.105V31.422zm0 0"
        ></path>
        <path
          fill="#020202"
          d="M131.484 35.727c.47-.028.938-.051 1.407-.063.214-.008.433-.016.652-.031 1.39-.086 1.39-.086 1.781.203.25.289.403.617.547.969.094.23.223.433.352.644.039.074.082.145.125.219.03.05.03.05.058.105.043.07.086.145.125.215l.188.328.11.188c.1.168.214.316.339.465.39-.528.754-1.074 1.117-1.625.977-1.485.977-1.485 1.11-1.617.101-.004.207-.008.308-.008h.2c.105 0 .105 0 .214.004h1.395c.386.004.777.004 1.164.004-.063.101-.13.203-.192.308-.039.055-.074.113-.109.172-.16.246-.328.488-.496.727-.371.53-.738 1.066-1.102 1.601-.156.235-.316.465-.472.7-.2.288-.399.581-.594.87-.05.079-.05.079-.106.157l-.199.293c-.027.043-.058.086-.09.133-.023.039-.05.074-.078.117-.054.078-.117.156-.175.234-.09.11-.09.11-.075.25.07.2.176.367.293.543l.063.098c.074.113.152.226.226.34.309.464.618.933.918 1.402.383.586.766 1.172 1.153 1.754.656.984.656.984.949 1.441l.082.117c.117.184.183.32.238.536h-3.633c-.156-.274-.308-.547-.468-.829a12.76 12.76 0 00-.313-.484 36.854 36.854 0 01-.66-1.059c-.203-.332-.406-.664-.617-.996a2.486 2.486 0 01-.067-.105c-.097-.16-.097-.16-.218-.3-.02.026-.036.054-.055.085-.238.363-.473.727-.707 1.094-.04.054-.074.113-.113.172-.446.691-.895 1.382-1.352 2.066-.023.063-.05.121-.078.188-.184.199-.234.195-.496.207-.14 0-.285-.004-.426-.008h-.227c-.199 0-.398-.004-.597-.008-.203-.004-.41-.008-.613-.008-.399-.004-.797-.012-1.196-.015.098-.262.23-.465.395-.684.261-.352.515-.707.765-1.066l.106-.153.21-.304c.173-.25.348-.504.524-.754.035-.047.067-.098.102-.149l.832-1.183c.12-.172.238-.344.36-.516.03-.047.062-.09.093-.137.059-.082.117-.168.176-.25.195-.277.394-.55.597-.82a3.832 3.832 0 00-.312-.535 2.887 2.887 0 00-.121-.18l-.121-.187c-.082-.122-.16-.239-.243-.36-.042-.062-.082-.125-.125-.191-.32-.477-.636-.957-.953-1.434-.132-.203-.265-.402-.398-.605-.043-.063-.043-.063-.086-.13a77.47 77.47 0 00-1.121-1.663 1.892 1.892 0 01-.27-.492zm0 0"
        ></path>
        <path
          fill="#010101"
          d="M88.36 32.602h3.105v3.125h2.695v2.476h-2.637c.004 1.047.004 1.047.012 2.09.004.426.008.855.008 1.281.004.344.004.688.008 1.031V43c.004.184.004.367.008.55-.004.055-.004.106-.004.165.007.367.039.777.28 1.066.349.309.661.336 1.103.332h.14c.363-.004.723-.035 1.082-.07l.176.84.059.285c.03.137.058.273.085.41.008.043.02.086.028.129.043.215.074.414.062.633a5.793 5.793 0 01-1.172.297l-.171.031c-.352.05-.707.039-1.063.043-.11 0-.11 0-.219.004-1.043.004-1.965-.258-2.746-.973-.941-.992-.855-2.523-.851-3.789v-.414c0-.36.004-.719.004-1.074 0-.371 0-.738.003-1.106 0-.718 0-1.437.004-2.156h-1.816v-2.476h1.816v-3.125zm0 0"
        ></path>
        <path
          fill="#020202"
          d="M82.559 31.422h3.164V47.52h-3.164V31.422zm0 0"
        ></path>
        <path
          fill="#FDFDFD"
          d="M127.383 38.262c.707.511 1 1.226 1.172 2.062.164 1.305.21 2.946-.606 4.055-.379.46-.797.77-1.386.898-.2.016-.395.016-.594.016-.051 0-.106 0-.16.004-.676.004-1.153-.188-1.641-.656-.629-.664-.832-1.614-.844-2.504V42v-.29c-.004-.097-.004-.194-.004-.292-.02-1.02.13-2.105.856-2.89.898-.786 2.18-.837 3.207-.266zm0 0M113.309 37.941h.156c.398.012.73.075 1.086.262.062.031.125.067.187.098.703.582.95 1.258 1.102 2.14.012.063.023.121.031.184.11.965.098 1.957-.207 2.883-.02.058-.035.113-.055.176-.195.562-.605 1.105-1.144 1.37-.715.298-1.55.352-2.278.067a2.378 2.378 0 01-1.214-1.379c-.215-.68-.262-1.347-.258-2.058v-.45c-.008-.98.168-1.879.847-2.629a2.447 2.447 0 011.747-.664zm0 0"
        ></path>
        <path
          fill="#FCFCFC"
          d="M77.012 42.27c.054-.004.113-.004.172-.004.246 0 .496.004.746.004.039.878.047 1.558-.54 2.265-.628.649-1.406.88-2.288.895-.493-.004-.875-.07-1.25-.418-.309-.34-.348-.684-.34-1.13.047-.41.215-.726.531-.984.621-.41 1.293-.48 2.012-.57l.175-.023c.262-.028.52-.035.782-.035zm0 0M65.629 38.223c.437.382.648.886.758 1.453v.59h-4.98c0-.743.202-1.286.698-1.836.926-.899 2.489-.97 3.524-.207zm0 0"
        ></path>
        <path
          fill="#CFEDFE"
          d="M34.746 32.012l.117.058c.004 1.89.008 3.782.008 5.672v.672c0 .043 0 .086.004.133v2.16c.004.738.004 1.477.004 2.215 0 .453 0 .91.004 1.367V45.766c.004.195.004.39 0 .586.004.086.004.086.004.171V46.82l-.024.11-.175.117.058-15.035zm0 0"
        ></path>
        <path
          fill="#2869AD"
          d="M26.074 32.426c.211.086.395.168.594.281.059.031.113.066.176.098.062.035.12.07.187.105.063.04.125.074.192.113.465.262.925.528 1.386.793l.176.106c.059.031.113.062.168.098.047.027.098.054.145.085.047.028.093.06.14.09.051.032.102.063.153.098.14.137.14.137.175.32v.758c-.003.098 0 .195 0 .293 0 .27-.003.535-.003.8-.004.282-.004.56-.004.837 0 .527-.004 1.054-.008 1.582 0 .601-.004 1.203-.004 1.804-.004 1.235-.008 2.47-.016 3.708h-.058v-.157l-.012-3.71c0-.598-.004-1.196-.004-1.794 0-.523-.004-1.043-.004-1.562-.004-.277-.004-.555-.004-.832 0-.258 0-.516-.004-.778v-.285-.39-.223c-.015-.18-.015-.18-.144-.285a2.05 2.05 0 00-.367-.16c-.122-.04-.122-.04-.223-.082-.027-.059-.027-.059-.059-.121-.097-.055-.097-.055-.21-.106a2.522 2.522 0 01-.454-.27c-.215-.16-.441-.28-.675-.41-.247-.132-.489-.273-.731-.414a2.373 2.373 0 00-.45-.214v9.847h-.058V32.426zm0 0"
        ></path>
        <path
          fill="#276AA9"
          d="M32.285 29.95c.434.16.832.413 1.23.648.094.054.094.054.192.113.52.316.848.656 1.04 1.242.03.211.03.414.03.625v5.859c-.004.668 0 1.336 0 2.004V46.34c-.004.469-.113.945-.406 1.32-.39.387-.39.387-.621.387v-.117c.05-.024.05-.024.105-.043.141-.082.211-.16.313-.29.086-.113.086-.113.168-.199h.117v-.527c.04-.02.078-.039.117-.062.078-.309.067-.63.067-.946v-.183-.602-.43-.925c-.004-.446-.004-.895-.004-1.34v-2.176-2.11-.132-.653c0-1.804-.004-3.613-.004-5.417h-.176c-.027-.262-.027-.262-.058-.532l-.176-.058c-.028-.059-.028-.059-.059-.117l-.176-.06-.058-.116c-.117-.04-.117-.04-.235-.059v-.121l-.129-.047a7.122 7.122 0 01-.464-.215l-.149-.07a1.237 1.237 0 01-.312-.258c-.117-.058-.235-.12-.352-.176v-.117zm0 0"
        ></path>
        <path
          fill="#D4EDFE"
          d="M31.113 33.426c.188.191.184.36.184.617v.739c0 .109.004.222.004.331v1.48c0 .59.004 1.184.004 1.778v2.05c.004.528.004 1.06.004 1.587v1.839c0 .11 0 .22.003.325V44.75c-.003.3-.07.5-.199.762h-.058v-.293h.117c-.02-3.89-.04-7.782-.059-11.793zm0 0"
        ></path>
        <path
          fill="#D2EEFE"
          d="M26.016 32.25a.576.576 0 01.234.059l.059.175-.235-.058v10.023a4.203 4.203 0 01-.566-.273c-.047-.028-.098-.059-.149-.086a3.1 3.1 0 00-.152-.09l-.156-.094a19.628 19.628 0 01-.383-.226l.234-.059v.121l.114.043c.32.13.632.27.941.426-.008-.05-.02-.098-.027-.152a3.478 3.478 0 01-.035-.606v-.117-.395c.003-.093.003-.187.003-.28 0-.255.004-.509.004-.766 0-.266.004-.532.004-.797.004-.45.008-.895.008-1.344l.012-1.555c.004-.496.004-.992.008-1.492.003-.21.003-.422.003-.637.004-.246.004-.496.004-.746.004-.094.004-.183.004-.277 0-.121 0-.246.004-.371v-.215c.008-.152.008-.152.067-.211zm0 0"
        ></path>
        <path
          fill="#BCDCF0"
          d="M13.242 33.781c-.094.055-.094.055-.187.114-.082.046-.164.097-.246.144-.04.023-.082.05-.121.074a3.33 3.33 0 01-.122.07c-.035.024-.07.044-.109.067-.105.063-.105.063-.21.18-.02.18-.02.18-.017.394v.121c-.003.137-.003.274-.003.414v.293c-.004.266-.004.535-.004.801 0 .281-.004.559-.004.836-.004.531-.004 1.059-.008 1.586 0 .602-.004 1.203-.008 1.805-.004 1.238-.012 2.476-.015 3.715l-.176-.06v-.148c0-1.18.004-2.355.004-3.535v-1.707-1.488c0-.266 0-.527.004-.789v-.742-.274-.37-.212c0-.172 0-.172-.067-.343a2.02 2.02 0 01.235-.532c.136-.074.136-.074.292-.12.106-.071.207-.15.31-.227.16-.106.276-.157.452-.067zm0 0"
        ></path>
        <path
          fill="#296AAB"
          d="M15.645 32.367V42.45c-.172-.258-.184-.433-.18-.738v-.117c0-.13 0-.262.004-.39v-.282c.004-.254.004-.508.008-.762 0-.265 0-.531.003-.797l.012-1.508.012-1.718.023-3.535-.351.058c.386-.293.386-.293.469-.293zm0 0"
        ></path>
        <path
          fill="#206BB7"
          d="M7.5 31.07c0 .176 0 .176-.059.278-.082.187-.066.347-.058.547-.117.02-.23.039-.352.058.004 1.883.004 3.77.012 5.652v.801c.004.715.004 1.434.004 2.149 0 .738.004 1.472.004 2.207.004.457.004.91.004 1.363 0 .348 0 .695.004 1.043v1.184c.003.336.058.578.21.878.067.133.094.258.114.407-.266-.223-.387-.508-.426-.852-.008-.16-.008-.32-.008-.48v-.188-.613c0-.149-.004-.293-.004-.441v-1.075-.87-.255-.125c-.004-.793-.004-1.582 0-2.37 0-.723-.004-1.446-.004-2.165-.003-.742-.003-1.484-.003-2.226v-1.25a58.99 58.99 0 010-1.176c0-.14 0-.285-.004-.43 0-.195 0-.39.003-.586-.003-.058-.003-.113-.003-.172.007-.472.156-.855.468-1.21.032-.028.063-.055.098-.083zm0 0"
        ></path>
        <path
          fill="#2A6BB6"
          d="M30.059 32.66h.234v.117c.137.02.27.04.41.063.02-.04.04-.078.059-.121l.175.058c.008.047.012.09.02.137.043.18.086.215.215.336.168.281.2.516.2.836v.969c.003.308.003.62.003.93-.004.261 0 .519 0 .78v3.727c0 .543.004 1.086 0 1.625 0 .324 0 .649.004.973v1.84c-.004.312-.078.465-.266.703l-.117-.059c.027-.035.055-.07.086-.105.176-.258.156-.524.156-.824v-.141-.469c0-.113.004-.222.004-.336v-.91-.566c0-.594.004-1.184.004-1.778v-2.05c.004-.532.004-1.06.004-1.586v-.95-.89c0-.11 0-.219.004-.328v-.446-.129a1.226 1.226 0 00-.2-.699c-.199-.187-.425-.316-.663-.453-.11-.062-.223-.125-.332-.195v-.059zm0 0"
        ></path>
        <path
          fill="#2D6CAF"
          d="M11.426 32.602h.234v.117l-.168.093c-.074.04-.148.083-.222.122l-.114.058c-.297.168-.511.36-.668.672-.008.148-.008.297-.008.445v.145c-.003.156-.003.312-.003.473V35.98c-.004.192-.004.383-.004.575v1.797c-.004.691-.004 1.382-.008 2.074v1.601c0 .32 0 .637-.004.957v1.231a8.76 8.76 0 000 .453c0 .043-.004.086-.004.129.004.371.121.687.383.953-.16-.023-.223-.047-.332-.172-.153-.246-.145-.48-.145-.762v-.144-.477-.343c0-.313 0-.622-.004-.934v-.777-1.836-1.895-1.629c0-.324 0-.648-.004-.968v-.915-.336-.46-.133c.004-.297.047-.551.133-.836.102-.078.102-.078.219-.102.172-.05.3-.101.45-.203.152-.11.152-.11.269-.11v-.116zm0 0"
        ></path>
        <path
          fill="#E2FCFE"
          d="M10.43 33.664c.136.215.133.426.129.676V35.238c0 .23 0 .461-.004.692v1.09c-.004.835-.004 1.671-.008 2.511-.004.766-.004 1.535-.008 2.301v1.082c-.004.227-.004.45-.004.676v.312c-.008.723-.008.723.13 1.434l.058.238h.175v.117l.293-.058c.024.043.047.09.07.137.122.18.204.203.4.273l.058.18a4.335 4.335 0 01-.676-.332c-.066-.04-.133-.075-.2-.114a1.147 1.147 0 01-.433-.738 3.922 3.922 0 01-.008-.371v-.145-.472-.34c0-.309 0-.613.004-.922v-.96c.004-.61.004-1.216.008-1.825 0-.691.004-1.383.004-2.074l.012-4.266zm0 0"
        ></path>
        <path
          fill="#156CCE"
          d="M15.527 32.602v9.492h-.058c-.02-3.055-.04-6.11-.059-9.254h-.234c-.02.055-.04.113-.059.176l-.207.011c-.246.028-.379.118-.57.27-.16.113-.32.148-.512.191v.117c-.074.04-.148.083-.223.122l-.125.066c-.12.047-.12.047-.296-.012l.12-.07c.184-.11.368-.215.555-.324.063-.035.125-.075.188-.114.308-.18.617-.359.914-.558.18-.102.363-.113.566-.113zm0 0"
        ></path>
        <path
          fill="#DBFDFE"
          d="M15.645 32.484h.058v9.727c.27-.106.461-.227.692-.39a.964.964 0 01.363-.141v.18c-.098.054-.195.105-.293.16-.055.03-.11.062-.164.093-.219.114-.438.223-.656.336v-9.965zm0 0"
        ></path>
        <path
          fill="#196BC7"
          d="M29.414 34.844h.059c.011 1.254.023 2.508.027 3.761l.012 1.75c.008.504.008 1.012.011 1.52 0 .27 0 .54.004.809.004.254.004.504.004.757 0 .094.004.188.004.282.016.699.016.699-.176.918-.136.093-.265.16-.414.222-.066.043-.136.082-.203.125-.086.055-.086.055-.176.106-.086.05-.086.05-.175.105-.149.078-.149.078-.266.078.027-.117.027-.117.059-.234h.293v-.117c.035-.008.07-.016.105-.02.133-.031.133-.031.215-.133.09-.086.09-.086.324-.086l.059-.175.117.058v-.117h.117v-9.61zm0 0"
        ></path>
        <path
          fill="#3071B6"
          d="M20.95 39.48c.046.028.093.051.144.079.047.023.093.05.14.074a23989.122 23989.122 0 01.313.18c.058.03.117.066.176.101.062.031.12.066.183.102.387.222.774.449 1.157.675.53.317 1.07.625 1.605.93-.219.066-.32.04-.527-.059v-.117c-.043-.015-.082-.03-.125-.047-.176-.074-.348-.16-.52-.246v-.12c-.055-.005-.11-.012-.164-.016-.187-.043-.187-.043-.266-.121-.128-.13-.27-.192-.433-.27a11.416 11.416 0 01-.778-.418v-.117l-.125-.031c-.05-.016-.105-.032-.16-.047-.054-.016-.105-.028-.16-.043-.14-.055-.14-.055-.258-.235a1.107 1.107 0 00-.84.13 2.25 2.25 0 00-.363.331c-.144.13-.144.13-.367.149-.062-.008-.125-.012-.187-.02.218-.242.503-.383.785-.547.054-.035.11-.07.168-.105.078-.047.078-.047.16-.094.05-.027.097-.058.148-.09.145-.047.145-.047.293-.008zm0 0"
        ></path>
        <path
          fill="#236BB8"
          d="M12.188 34.43h.058v9.906l.234.117a.856.856 0 01.06.234c-.11-.019-.11-.019-.235-.058-.145-.215-.133-.32-.133-.578v-.125c0-.137 0-.278.004-.414v-.297-.805-.84c0-.53.004-1.062.004-1.593V38.16c.004-1.242.004-2.488.008-3.73zm0 0"
        ></path>
        <path
          fill="#2C70B9"
          d="M18.223 28.71c.12.028.12.028.234.06-.035.02-.074.043-.11.062-.882.5-.882.5-1.757 1.02-.602.363-1.215.71-1.828 1.058-.14.082-.282.164-.418.246-.164.09-.164.09-.281.09v-.117c.046-.016.093-.035.144-.05.156-.052.156-.052.207-.188h.234v-.118h.118v-.117h.293l.058-.176c.207-.07.207-.07.41-.117.02-.078.04-.156.059-.238l.293.059.059-.176a.89.89 0 01.468-.117l.059-.176h.176v-.121c.035-.012.066-.028.101-.04.524-.21.524-.21.895-.609.117-.047.117-.047.261-.09.18-.046.18-.046.325-.144zm0 0"
        ></path>
        <path
          fill="#2E6FB6"
          d="M24.61 53.414c-.692.406-1.38.813-2.075 1.211-.047.027-.094.059-.144.086-1.266.727-1.266.727-1.985.55-.125-.042-.246-.09-.367-.136.2-.066.324-.047.527 0 .454.035.844.016 1.23-.238l.06-.117h.292v-.118h.176c.028-.09.028-.09.059-.175.117-.043.234-.082.351-.122l.059-.117c.117-.062.234-.12.352-.175.062-.036.125-.067.187-.102.164-.074.164-.074.34-.074v-.121l.293-.059v-.117c.074-.04.148-.082.223-.121l.125-.07c.12-.044.12-.044.296.015zm0 0"
        ></path>
        <path
          fill="#3171B6"
          d="M17.813 49.816c.261.079.472.184.703.332.066.04.132.082.199.125.035.024.07.043.105.067.278.176.555.34.836.504l.211.129c.516.332.516.332 1.106.41.23-.063.418-.176.617-.301.144-.094.289-.18.441-.262l.117.059c-.078.086-.078.086-.175.176h-.176v.117a42.45 42.45 0 00-.527.18v.117h-.88v-.117l-.14-.036-.18-.043c-.086-.023-.086-.023-.175-.043l-.149-.058c-.027-.086-.027-.086-.058-.176-.176-.07-.176-.07-.352-.117v-.117a1.45 1.45 0 00-.129-.016c-.195-.055-.3-.152-.457-.281l-.234-.059-.078-.078a1.539 1.539 0 00-.372-.258 2.619 2.619 0 01-.144-.078 2.78 2.78 0 00-.11-.058v-.118zm0 0"
        ></path>
        <path
          fill="#E1F6FC"
          d="M16.934 25.586l-.114.062c-.742.415-1.48.832-2.203 1.274a12.9 12.9 0 01-1.023.55l.058-.175h.118v-.117h.234v-.121c.137-.13.207-.172.394-.188.067.008.067.008.133.012l.059-.352.117.059c.137-.059.273-.117.41-.18h.235c.007-.043.02-.09.03-.133.114-.207.22-.234.434-.308.121-.028.121-.028.356-.028v-.117h.176v-.12c.343-.196.343-.196.586-.118zm0 0"
        ></path>
        <path
          fill="#0E6FD1"
          d="M30.879 45.691v.176c-.067.035-.129.074-.195.11-.086.046-.172.097-.258.144a2.18 2.18 0 00-.13.074c-.206.114-.405.23-.589.38h.176c-.012.105-.012.105-.059.234-.258.195-.449.18-.762.18l.235-.118c-.277 0-.473.191-.692.344-.277.191-.277.191-.433.164-.05-.02-.05-.02-.106-.04.664-.394 1.332-.784 2.004-1.171.063-.035.125-.074.188-.11.058-.035.113-.066.172-.097l.449-.27zm0 0"
        ></path>
        <path
          fill="#326FB3"
          d="M26.133 32.426l.644.351c.035.024.075.043.114.063.566.312 1.132.637 1.691.965l.184.105c.058.031.113.067.172.102.05.027.101.058.156.09.426.273.426.273.465.453-.008.117-.02.23-.028.347h-.058a3.287 3.287 0 00-.016-.195c-.023-.215-.023-.215-.133-.32a3.597 3.597 0 00-.512-.207c-.101-.043-.101-.043-.16-.164-.097-.055-.097-.055-.21-.106a2.522 2.522 0 01-.454-.27c-.215-.16-.441-.28-.675-.41-.247-.132-.489-.273-.731-.414a2.373 2.373 0 00-.45-.214v-.176zm0 0"
        ></path>
        <path
          fill="#3071B8"
          d="M32.285 29.95c.434.16.832.413 1.23.648.094.054.094.054.192.113.504.305.875.656 1.04 1.242-.017.211-.017.211-.06.356h-.058v-.414h-.176c-.027-.262-.027-.262-.058-.532l-.176-.058c-.028-.059-.028-.059-.059-.117l-.176-.06-.058-.116c-.117-.04-.117-.04-.235-.059v-.121l-.129-.047a7.122 7.122 0 01-.464-.215l-.149-.07a1.237 1.237 0 01-.312-.258c-.117-.058-.235-.12-.352-.176v-.117zm0 0"
        ></path>
        <path
          fill="#2F72BC"
          d="M24.375 49.465l.117.058-.097.059c-.04.027-.082.055-.125.082l-.125.078c-.223.133-.223.133-.372.336-.14.207-.277.254-.511.328-.203.012-.203.012-.352 0v.176c-.098.04-.195.082-.293.121-.05.02-.101.043-.152.07-.14.047-.14.047-.317-.011.043-.028.086-.051.13-.075.16-.093.32-.187.484-.28.101-.06.203-.122.308-.18a13007.747 13007.747 0 00.403-.235c.132-.078.27-.156.402-.238.063-.04.125-.078.191-.117.059-.035.114-.07.172-.106l.137-.066zm0 0"
        ></path>
        <path
          fill="#2C6FBD"
          d="M24.082 29.184c.441.113.902.25 1.227.59.164.16.355.238.558.335.164.086.305.184.453.297.168.117.348.207.528.305.105.062.105.062.164.18a4.595 4.595 0 01-.75-.368c-.047-.023-.09-.05-.137-.074-.406-.23-.813-.465-1.219-.703l-.187-.105a6.634 6.634 0 00-.328-.196 1.522 1.522 0 01-.309-.261zm0 0"
        ></path>
        <path
          fill="#3372BC"
          d="M12.188 50.523c.265.032.468.102.703.239l.058.117c.137.062.274.121.41.176v.117c.036.012.075.02.114.031.343.094.668.203.941.442.027.085.027.085.059.175.097.02.191.04.293.059V52c-.317-.09-.579-.242-.86-.41-.097-.059-.199-.117-.297-.176a3.099 3.099 0 01-.152-.09l-.477-.277c-.05-.027-.101-.059-.156-.09a11.6 11.6 0 01-.297-.172c-.047-.023-.09-.05-.136-.078-.04-.02-.079-.043-.118-.066l-.085-.059v-.059zm0 0"
        ></path>
        <path
          fill="#3274BA"
          d="M22.148 23.996c-.175.055-.226.059-.41 0-.058-.058-.117-.121-.175-.18-.465-.156-1.043-.066-1.524 0v.122c-.289.132-.574.257-.879.351.16-.187.371-.3.582-.418.035-.023.074-.043.11-.066.789-.453 1.566-.258 2.296.191zm0 0"
        ></path>
        <path
          fill="#2E70B8"
          d="M8.262 48.227c.394.05.394.05.527.117v.176a.72.72 0 00.098.02c.164.046.312.112.468.183.06.027.118.05.176.078.137.074.137.074.196.191.187.094.382.176.574.258.18.09.289.18.422.332l-.059.117c-1.5-.867-1.5-.867-2.059-1.203l-.109-.062a7.773 7.773 0 01-.234-.149v-.058zm0 0"
        ></path>
        <path
          fill="#E0F6FD"
          d="M19.219 54.652c.062.032.125.067.191.098l.25.129c.043.023.086.043.125.066.586.297 1.137.375 1.777.239-.019.058-.039.113-.058.175-.586.133-1.106.094-1.64-.175-.04-.02-.075-.04-.114-.055-.082-.04-.16-.082-.238-.125v-.117c-.145-.059-.145-.059-.293-.117v-.118zm0 0"
        ></path>
        <path
          fill="#3171B9"
          d="M27.95 45.277l.175.059c-.219.129-.438.262-.652.39l-.223.133-.32.192-.196.117c-.062.035-.125.074-.191.113-.035.02-.07.043-.11.067-.277.172-.277.172-.5.132-.152-.082-.152-.082-.21-.199l.18.008a1.99 1.99 0 00.64-.129v-.117c.117-.02.23-.04.352-.059l.058-.175c.149-.082.149-.082.324-.16a2.49 2.49 0 00.18-.079c.047-.02.094-.035.14-.058v-.176c.071.004.071.004.145.004.145.015.145.015.207-.063zm0 0"
        ></path>
        <path
          fill="#2B71BB"
          d="M21.152 43.625h.293v.121c.055.008.106.02.16.027.301.086.54.274.79.45.132.09.257.164.398.23v.117c.066.016.133.032.203.047.067.024.137.047.207.07.027.09.027.09.059.176-.356-.133-.676-.328-1.008-.52-.113-.066-.227-.128-.34-.195-.074-.043-.148-.082-.219-.125-.066-.039-.133-.074-.203-.113a1.482 1.482 0 01-.34-.285zm0 0"
        ></path>
        <path
          fill="#2E70B5"
          d="M17.11 25.41l.117.059c-.48.414-.48.414-.762.414V26h-.176l-.059.176c-.144.07-.293.117-.44.168-.153.058-.153.058-.235.191-.086.113-.086.113-.207.149l-.348.023c.145-.164.305-.258.496-.363.063-.035.129-.07.191-.11l.204-.109c.129-.074.261-.145.39-.219l.188-.101c.152-.09.3-.18.445-.278l.195-.117zm0 0"
        ></path>
        <path
          fill="#DCF5FC"
          d="M21.21 39.383v.176l.235.058v.117h.41l.036.114c.113.175.238.187.433.242l.117.058v.118l.176.058-.058.117c-.188-.101-.372-.203-.559-.304-.074-.043-.074-.043-.156-.086a10.847 10.847 0 01-.82-.492 1.065 1.065 0 00-.34-.118v-.058c.199-.051.332-.067.527 0zm0 0"
        ></path>
        <path
          fill="#3473B4"
          d="M15.176 32.66c.027.09.027.09.058.18-.136.156-.226.2-.433.23-.246.047-.367.133-.563.297-.136.055-.27.086-.41.121v.117c-.074.04-.148.083-.223.122l-.125.066c-.12.047-.12.047-.296-.012l.12-.07c.184-.11.368-.215.555-.324.063-.035.125-.075.188-.114.277-.16.547-.32.816-.492.196-.12.196-.12.313-.12zm0 0"
        ></path>
        <path
          fill="#3474BA"
          d="M13.535 45.277c.137.02.27.04.41.059l.059.176c.098.02.191.039.293.062v.117c.047.008.094.012.14.02.153.039.153.039.27.156.11.035.219.067.328.098.059.012.117.027.18.043.066.02.066.02.137.035l.058.297a3.11 3.11 0 01-.687-.309c-.063-.035-.125-.07-.188-.11-.098-.054-.098-.054-.195-.112-.063-.04-.13-.075-.195-.114-.477-.285-.477-.285-.61-.418zm0 0"
        ></path>
        <path
          fill="#3375BA"
          d="M26.484 48.227l.118.058c-.118.176-.118.176-.27.215-.07.012-.07.012-.14.02l-.06.175c-.183.125-.37.149-.585.18v.117l-.207.102a6.43 6.43 0 00-.485.27l-.187.1-.176-.058.121-.07c.18-.11.364-.215.547-.32.063-.04.121-.075.188-.114l.187-.109c.09-.05.09-.05.184-.105.218-.133.437-.27.652-.407l.113-.054zm0 0"
        ></path>
        <path
          fill="#3D78B6"
          d="M19.395 40.324v.117c-.079.02-.157.04-.235.063-.02.094-.039.191-.058.293l-.153-.012c-.242.016-.36.09-.562.219-.325.207-.325.207-.516.207v.117c-.164.09-.164.09-.351.176l-.176-.059c.05-.027.05-.027.101-.058l.47-.27c.085-.047.085-.047.17-.097.36-.208.716-.415 1.071-.63.121-.066.121-.066.239-.066zm0 0"
        ></path>
        <path
          fill="#3172B8"
          d="M14.766 52c.187.04.363.105.543.18.05.02.105.043.156.062.058.028.058.028.12.051v.176l.102.031c.305.098.563.215.836.383V53c.07.027.07.027.145.05.148.067.148.067.207.188a4.666 4.666 0 01-.629-.304c-.062-.036-.129-.07-.191-.106-.102-.058-.102-.058-.203-.113-.063-.04-.13-.074-.196-.113a10.828 10.828 0 01-.89-.543V52zm0 0"
        ></path>
        <path
          fill="#E2F7FD"
          d="M11.66 32.719c-.074.222-.172.273-.351.414-.059.086-.059.086-.118.176-.058.007-.113.02-.171.027-.184.016-.184.016-.278.152l-.078.117-.176.06c.094-.364.364-.548.668-.74.36-.206.36-.206.504-.206zm0 0"
        ></path>
        <path
          fill="#3573B9"
          d="M18.105 53.945h.235v.117l.144.04c.22.082.41.187.614.308.125.07.125.07.297.125l.058.117c.172.078.344.133.527.176.028.117.028.117.06.234a3.166 3.166 0 01-.688-.3l-.188-.11a3.083 3.083 0 00-.191-.113 4.907 4.907 0 00-.192-.113c-.52-.305-.52-.305-.676-.48zm0 0"
        ></path>
        <path
          fill="#2C70BA"
          d="M29.297 50.64c-.281.25-.602.422-.926.606l-.176.102c-.14.078-.28.16-.422.238l-.117-.117h.117v-.117a3.35 3.35 0 01.762-.297v-.117c.254-.227.426-.305.762-.297zm0 0"
        ></path>
        <path
          fill="#D6F2FB"
          d="M29.531 44.336c.02.078.04.152.059.234-.586.532-.586.532-.938.532l-.058.175c-.121.043-.121.043-.266.07-.05.008-.098.02-.148.028-.04.008-.075.016-.114.02a1.61 1.61 0 01.43-.329l.149-.082c.101-.058.207-.113.308-.172.074-.042.074-.042.149-.082.043-.027.09-.05.132-.078.133-.09.207-.187.297-.316zm0 0"
        ></path>
        <path
          fill="#3374B7"
          d="M13.77 31.48c-.223.133-.442.262-.665.391-.058.04-.12.074-.187.113-.395.23-.793.457-1.2.676v-.176c.052-.023.098-.047.15-.074l.194-.094c.063-.03.13-.066.196-.097.168-.078.168-.078.281-.207h.176v-.117c.14-.082.285-.16.43-.239.058-.035.058-.035.12-.07.31-.168.31-.168.505-.106zm0 0"
        ></path>
        <path
          fill="#2B72C0"
          d="M12.54 46.75c.292.105.558.258.827.41.047.028.094.05.145.078.043.028.09.051.136.078l.125.07c.114.075.2.153.29.25-.165.012-.165.012-.352 0a7.711 7.711 0 01-.176-.179c-.058-.008-.117-.016-.18-.023a13.087 13.087 0 00-.171-.036l-.118-.234c-.058-.02-.113-.035-.171-.055-.18-.062-.18-.062-.29-.218l-.066-.141zm0 0"
        ></path>
        <path
          fill="#D4F4FD"
          d="M20.898 43.516c.2.074.364.175.547.289-.097.066-.097.066-.234.117-.16-.05-.16-.05-.293-.117v-.117c-.398.14-.398.14-.75.367-.129.101-.129.101-.293.117a1.45 1.45 0 01-.129-.016 7.45 7.45 0 01.613-.426c.047-.035.047-.035.098-.066.156-.102.254-.156.441-.148zm0 0"
        ></path>
        <path
          fill="#2F72B7"
          d="M19.043 24.29l.117.058c-.336.238-.336.238-.469.238v.117c-.046.02-.046.02-.093.043-.27.129-.27.129-.5.317-.141.14-.274.171-.461.23l-.176.117c-.129-.023-.129-.023-.234-.058a38.645 38.645 0 00.691-.398l.234-.134c.114-.066.227-.129.34-.195.051-.031.051-.031.106-.059.152-.09.3-.18.445-.277zm0 0"
        ></path>
        <path
          fill="#DBF4FC"
          d="M31.23 49.582l-.058.176h-.176v.176c-.035.015-.07.03-.105.043-.215.093-.399.171-.578.328-.172.129-.278.12-.489.101.133-.144.266-.238.434-.336.047-.027.097-.058.148-.086.051-.03.102-.058.153-.09.054-.03.105-.058.156-.09.383-.222.383-.222.515-.222zm0 0"
        ></path>
        <path
          fill="#286EB1"
          d="M32.871 48.344c.145.027.145.027.293.058a4.445 4.445 0 01-.477.325c-.042.023-.085.05-.132.078l-.137.082-.14.082c-.118.066-.231.133-.344.199-.059-.176-.059-.176 0-.352l.191-.015c.242-.051.29-.106.453-.281h.234l.06-.176zm0 0"
        ></path>
        <path
          fill="#246DBE"
          d="M34.629 46.457h.059c.039.508-.063.805-.344 1.223a1.895 1.895 0 01-.477.367h-.117v-.117c.035-.016.07-.028.105-.043.141-.082.211-.16.313-.29.086-.113.086-.113.168-.199h.117v-.527c.04-.02.078-.039.117-.062.04-.176.04-.176.059-.352zm0 0"
        ></path>
        <path
          fill="#E3F7F9"
          d="M21.621 27.828c.2.074.383.16.567.27.046.03.097.058.148.09a3.1 3.1 0 01.152.09c.051.03.106.058.157.09.128.073.253.152.382.226l-.058.117-.137-.07a8.44 8.44 0 00-1.035-.461l-.117-.059c-.035-.152-.035-.152-.059-.293zm0 0"
        ></path>
        <path
          fill="#2F73BB"
          d="M11.426 32.602h.234v.117l-.168.093c-.074.04-.148.083-.222.122l-.114.058c-.265.149-.426.309-.61.555l-.116.117c-.02-.379-.02-.379.066-.52.145-.093.297-.132.461-.187.117-.078.234-.156.352-.238h.117v-.117zm0 0"
        ></path>
        <path
          fill="#0F6ECF"
          d="M30.938 49.05c.035.009.07.02.105.032.137.035.137.035.305.027l.058.176.41-.117a1.54 1.54 0 01-.441.336l-.14.078c-.122.059-.122.059-.239.059 0-.067.004-.13.004-.196.008-.215.008-.215-.063-.394zm0 0"
        ></path>
        <path
          fill="#DAF3FC"
          d="M31.172 29.242c.168-.015.265-.015.41.074.059.047.059.047.113.094.192.156.352.242.59.305v.117c.043.004.086.008.133.016.191.05.266.129.395.277l-.118.059c-.14-.067-.14-.067-.316-.168-.063-.04-.125-.075-.188-.114l-.199-.117-.199-.117c-.488-.29-.488-.29-.621-.426zm0 0"
        ></path>
        <path
          fill="#3171BA"
          d="M17.168 41.563v.18c-.395.234-.395.234-.527.234-.016.035-.028.074-.043.113-.094.152-.157.168-.328.219-.07.02-.07.02-.141.043-.043.011-.086.023-.133.039a4.577 4.577 0 00-.293.117v-.117l1.465-.828zm0 0"
        ></path>
        <path
          fill="#F5FBFB"
          d="M32.813 30.184c.218-.012.28-.008.468.12.04-.019.078-.038.117-.062v.18l.293-.117c.02.039.04.074.059.117l-.059.176.176.058.059.176a2.72 2.72 0 01-.754-.355c-.035-.024-.07-.043-.106-.067a5.709 5.709 0 01-.254-.168v-.058zm0 0"
        ></path>
        <path
          fill="#E0F4FB"
          d="M23.438 50.055c-.348.21-.696.425-1.055.648-.02-.058-.04-.117-.059-.18l.176-.117.023-.117.036-.117c.148-.074.148-.074.293-.117v.175h.175v-.117c.211-.125.211-.125.41-.058zm0 0"
        ></path>
        <path
          fill="#3373B7"
          d="M14.18 27.121l.117.059c-.336.234-.336.234-.469.234l-.058.176a4.576 4.576 0 01-.293.117c-.18.105-.356.215-.532.324-.16.086-.285.125-.465.149.227-.254.543-.403.832-.57.11-.063.215-.126.325-.188.066-.043.136-.082.203-.121.062-.035.125-.074.191-.11l.149-.07zm0 0"
        ></path>
        <path
          fill="#3171B7"
          d="M10.84 45.75c.586.281 1.14.605 1.7.941-.22.067-.22.067-.356.004l-.118-.082a1.448 1.448 0 00-.406-.215v-.117h-.293v-.18l-.293-.058v-.117l-.234-.059v-.117zm0 0"
        ></path>
        <path
          fill="#D6F0FC"
          d="M23.086 28.652c.945.504.945.504 1.406.766l-.117.117c-.2-.02-.336-.117-.5-.23a3.03 3.03 0 00-.496-.297v-.121c-.098-.02-.192-.04-.293-.059v-.176zm0 0"
        ></path>
        <path
          fill="#316FB6"
          d="M23.086 24.586c.586.273 1.14.613 1.7.941l-.118.118-.105-.063a17.218 17.218 0 00-1.36-.762v-.117l-.176-.058.059-.06zm0 0"
        ></path>
        <path
          fill="#256FC2"
          d="M24.375 49.465l.117.058c-.031.02-.062.04-.097.059-.04.027-.082.055-.125.082l-.125.078c-.223.13-.223.13-.364.336-.164.227-.375.262-.636.328.074-.082.152-.16.234-.234h.117c0-.035.004-.067.004-.102.086-.21.27-.285.46-.39.04-.02.075-.043.114-.067.098-.054.2-.101.301-.148zm0 0"
        ></path>
        <path
          fill="#D3F1FB"
          d="M28.477 51.172c-.082.254-.247.34-.47.473-.19.074-.19.074-.35.117l-.177.058v.121h-.293c.125-.136.25-.23.407-.324.043-.027.09-.054.133-.078l.136-.082.14-.082c.34-.203.34-.203.474-.203zm0 0"
        ></path>
        <path
          fill="#2A6FB9"
          d="M29.297 44.453l.176.059c-1.106.765-1.106.765-1.348.765l.059-.234h.293v-.117c.035-.008.07-.016.105-.02.133-.031.133-.031.215-.133.09-.086.09-.086.324-.086l.059-.175.117.058v-.117zm0 0"
        ></path>
        <path
          fill="#3271B2"
          d="M25.313 29.89c.378.098.656.255.964.485.184.129.375.234.575.34.101.058.101.058.16.176-.29-.102-.551-.254-.817-.403-.047-.027-.093-.05-.14-.078a8.09 8.09 0 01-.742-.46v-.06zm0 0"
        ></path>
        <path
          fill="#DEF5FB"
          d="M18.75 50.29c.195-.013.195-.013.41 0l.176.175c.117.07.117.07.246.129.043.02.082.043.125.062.031.016.066.032.098.047-.02.059-.04.113-.059.176-.234-.09-.445-.2-.664-.328-.062-.035-.125-.074-.187-.11l-.145-.093v-.059zm0 0"
        ></path>
        <path
          fill="#E2F8FD"
          d="M27.598 47.52l.117.058c-.16.094-.32.192-.48.285-.044.028-.09.055-.137.082-.22.133-.43.254-.672.34v-.176l.133-.047c.164-.062.164-.062.273-.19.148-.145.273-.18.473-.235l.16-.07.133-.047zm0 0"
        ></path>
        <path
          fill="#2C70BC"
          d="M24.727 41.68a10.828 10.828 0 01.387.227l.109.062c.222.129.445.25.675.36-.039.038-.078.077-.117.12-.234-.078-.468-.16-.703-.238v-.234c-.047-.016-.094-.032-.144-.047a5.373 5.373 0 00-.149-.07l-.058-.18zm0 0"
        ></path>
        <path
          fill="#3374BB"
          d="M27.656 51.645c-.21.128-.426.257-.636.382l-.184.114a4.061 4.061 0 00-.176.101 3.517 3.517 0 01-.16.098c-.133.07-.133.07-.25.07v-.117c.031-.016.066-.031.102-.047.043-.02.085-.043.128-.062l.13-.063c.117-.055.117-.055.167-.18h.176v-.12h.235v-.118c.335-.125.335-.125.468-.058zm0 0"
        ></path>
        <path
          fill="#DAF3FA"
          d="M29.473 50.523l.117.059c-.02.078-.04.156-.059.238-.07.012-.144.028-.215.04-.207.05-.253.078-.41.238-.066.066-.066.066-.136.132-.165-.007-.165-.007-.293-.058a5.2 5.2 0 01.656-.461c.058-.035.12-.07.183-.11.079-.038.079-.038.157-.078zm0 0"
        ></path>
        <path
          fill="#2C72BB"
          d="M23.906 44.863c-.02.078-.039.157-.058.239.191.097.386.195.586.293-.02.058-.04.117-.059.18-.367-.216-.734-.43-1.113-.65.078-.019.156-.038.234-.062.184-.058.234-.054.41 0zm0 0"
        ></path>
        <path
          fill="#136CCA"
          d="M16.941 52.934c.055.004.11.004.168.007v.176c.07.07.141.14.211.207.082.09.082.09.082.207-.328-.082-.523-.246-.761-.472.117-.118.117-.118.3-.125zm0 0"
        ></path>
        <path
          fill="#DCF5FC"
          d="M16.934 29.594c.039.02.078.039.117.062-.133.203-.258.29-.477.39-.183.079-.183.079-.344.196a3.664 3.664 0 01-.293 0c.165-.191.376-.3.59-.426.035-.023.075-.043.114-.066.093-.055.195-.105.293-.156zm0 0"
        ></path>
        <path
          fill="#E6F5F7"
          d="M34.336 47.578l.059.117c.097.043.195.082.292.117l-.117.235c-.199 0-.386-.027-.586-.059l.118-.175h.117l.117-.235zm0 0"
        ></path>
        <path
          fill="#316FB6"
          d="M30.879 45.691v.176c-.063.035-.129.074-.195.11-.086.046-.168.097-.254.144a2.18 2.18 0 00-.13.074c-.042.024-.081.047-.124.07-.043.024-.082.044-.121.067a3.336 3.336 0 00-.278.176c-.066.031-.066.031-.129.066l-.175-.058c.465-.274.93-.543 1.406-.825zm0 0"
        ></path>
        <path
          fill="#D9F1FB"
          d="M10.605 45.512l.293.062v.117l.293-.058c.024.043.047.09.07.137.122.18.204.203.4.273l.058.18a3.584 3.584 0 01-.688-.356c-.035-.02-.07-.043-.105-.062-.254-.16-.254-.16-.32-.293zm0 0"
        ></path>
        <path
          fill="#2B73BA"
          d="M18.164 44.926c.02.035.04.074.059.117a40.44 40.44 0 00-.707.418c-.051.027-.102.059-.153.086-.066.043-.066.043-.136.082-.118.062-.118.062-.235.062v-.117c.078-.039.156-.078.235-.12v-.118h.293v-.117h.234v-.117c.137-.059.27-.118.41-.176zm0 0"
        ></path>
        <path
          fill="#DAF4FD"
          d="M26.836 30.832c.441.215.867.457 1.289.711-.117.055-.117.055-.234.117l-.059-.117a3.153 3.153 0 01-.176-.063v-.117h-.41c-.02-.05-.02-.05-.039-.105-.098-.164-.21-.215-.371-.305v-.121zm0 0"
        ></path>
        <path
          fill="#3173B9"
          d="M14.941 48.11c.055.027.106.058.16.09.395.226.79.452 1.188.675-.184.059-.234.055-.41 0v-.117l-.14-.035a3.024 3.024 0 01-.798-.496v-.118zm0 0"
        ></path>
        <path
          fill="#3573B6"
          d="M29.473 46.574v.117c-.04.024-.082.043-.121.067-.329.176-.637.36-.934.582-.145.074-.2.047-.352 0 .028-.016.059-.031.086-.05.133-.08.262-.153.395-.231.043-.028.09-.055.137-.082.043-.028.086-.051.132-.079.063-.039.063-.039.13-.078.097-.058.19-.117.288-.175.121-.07.121-.07.239-.07zm0 0"
        ></path>
        <path
          fill="#DCF3FC"
          d="M14.707 30.953v.117h-.176l-.011.102c-.07.195-.165.265-.34.371-.223-.016-.223-.016-.41-.063.234-.203.609-.527.937-.527zm0 0"
        ></path>
        <path
          fill="#D8F3FB"
          d="M28.125 27.473c.25-.02.379.035.586.175l.117.059v.121l.176-.058c.09.078.09.078.176.175v.117h.117l-.059.118c-.187-.106-.37-.211-.558-.32-.078-.047-.078-.047-.16-.09a5.254 5.254 0 00-.153-.09l-.14-.082a4.33 4.33 0 01-.102-.067v-.058zm0 0"
        ></path>
        <path
          fill="#2B70BD"
          d="M18.926 50.523c.426.137.828.293 1.172.59v.117c-.176-.027-.176-.027-.352-.058l-.058-.176c-.176-.07-.176-.07-.352-.117v-.117c-.07-.016-.07-.016-.14-.028-.153-.03-.153-.03-.27-.093v-.118zm0 0"
        ></path>
        <path
          fill="#E1F8FC"
          d="M23.496 45.043c.742.363.742.363 1.055.59-.188.062-.23.05-.41 0h-.176a40.3 40.3 0 01-.059-.297l-.14-.023c-.153-.036-.153-.036-.27-.094v-.176zm0 0"
        ></path>
        <path
          fill="#D9F4FE"
          d="M25.254 48.816l.234.059c-.21.129-.425.254-.636.383-.063.035-.122.074-.184.11-.059.034-.117.07-.176.105a3.517 3.517 0 00-.16.097c-.133.07-.133.07-.25.07v-.175c.156-.04.309-.078.469-.121v-.117c.082-.047.168-.098.254-.145.047-.027.093-.055.14-.086.133-.062.133-.062.309-.062v-.118zm0 0"
        ></path>
        <path
          fill="#3271B5"
          d="M20.156 27.77c-.21.125-.426.253-.636.382a16335.606 16335.606 0 00-.52.313c-.133.07-.133.07-.25.07v-.117c.336-.18.336-.18.469-.18l.058-.175c.153-.098.153-.098.344-.192.063-.031.125-.062.192-.098.167-.066.167-.066.343-.003zm0 0"
        ></path>
        <path
          fill="#D7F2FC"
          d="M22.266 44.336c.418.203.828.414 1.23.648l-.117.118c-.125-.024-.125-.024-.234-.059v-.117l-.114-.043a6.14 6.14 0 01-.457-.219c-.07-.039-.07-.039-.14-.074-.11-.078-.11-.078-.168-.254zm0 0"
        ></path>
        <path
          fill="#1A6ECB"
          d="M13.535 31.246v.117h.293v-.117l.235.059a1.481 1.481 0 01-.442.21c-.133.044-.254.083-.379.145-.039-.098-.078-.195-.117-.297.156-.086.227-.117.41-.117zm0 0"
        ></path>
        <path
          fill="#DBF5FB"
          d="M15.586 30.363l.117.059c-.344.351-.508.488-.996.531.266-.234.563-.437.879-.59zm0 0"
        ></path>
        <path
          fill="#CCE7F7"
          d="M20.879 23.477c.05.003.105.003.16.007.387.028.387.028.523.098v.117c-.027-.008-.058-.02-.09-.027-.199-.043-.398-.043-.6-.047-.04 0-.083 0-.122-.004-.3 0-.5.067-.77.195l-.175.059c.07-.207.152-.262.34-.363.242-.09.48-.059.734-.035zm0 0"
        ></path>
        <path
          fill="#E2FAFD"
          d="M21.563 55.184c-.02.058-.04.113-.06.175-.23.055-.444.067-.679.07h-.203c-.172-.011-.172-.011-.348-.128l.2-.012c.086-.004.172-.012.257-.016.043 0 .086-.003.133-.007.239-.012.461-.082.7-.082zm0 0"
        ></path>
        <path
          fill="#DCF2FA"
          d="M17.637 49.64c.402.051.402.051.468.118l.118-.117.035.136c.105.207.222.246.433.336-.058.04-.117.078-.175.117-.149-.085-.293-.175-.438-.261-.043-.024-.086-.051-.129-.074-.105-.063-.207-.13-.312-.196v-.058zm0 0"
        ></path>
        <path
          fill="#3778BA"
          d="M27.012 30.89h.41c.012.047.023.094.031.141.074.18.074.18.29.219l.206.055c.113.125.113.125.176.238a2.847 2.847 0 01-.754-.36 1.567 1.567 0 01-.105-.066c-.086-.05-.172-.11-.254-.164v-.062zm0 0"
        ></path>
        <path
          fill="#D4F0FC"
          d="M24.668 41.621h.234v.121c.04.012.075.028.114.043.277.113.554.235.824.367v.118h.176v.12c-.32-.093-.586-.245-.871-.417l-.141-.082c-.246-.149-.246-.149-.336-.211v-.059zm0 0"
        ></path>
        <path
          fill="#CBEAF9"
          d="M21.094 27.473l.117.117-.148.023c-.063.008-.125.02-.192.032-.062.007-.129.015-.191.027-.184.027-.184.027-.348.156-.129-.023-.129-.023-.234-.058.343-.227.586-.348.996-.297zm0 0"
        ></path>
        <path
          fill="#3476BB"
          d="M16.055 26.176l-.059.117c-.055.02-.11.035-.168.05-.187.052-.187.052-.265.192-.114.137-.165.137-.34.156l-.223.016c.152-.172.332-.281.527-.398.063-.04.125-.075.188-.114.164-.078.164-.078.34-.02zm0 0"
        ></path>
        <path
          fill="#3171B9"
          d="M30.996 49.7c-.144.09-.289.175-.433.265a2.11 2.11 0 00-.122.078c-.312.187-.312.187-.441.187v-.117h.176v-.12c.078-.02.156-.036.234-.06v-.117c.344-.195.344-.195.586-.117zm0 0"
        ></path>
        <path
          fill="#D6F3FC"
          d="M30.938 45.512c.039.02.078.039.117.062-.164.192-.38.301-.598.422-.039.024-.074.043-.117.066-.094.051-.188.106-.281.16a9.823 9.823 0 01-.059-.179c.18-.094.352-.176.547-.238.164-.04.164-.04.215-.172.058-.04.117-.078.175-.121zm0 0"
        ></path>
        <path
          fill="#2D74BD"
          d="M12.832 44.629l.059.234.351.063v.117l.235.059v.117c-.348-.09-.645-.27-.938-.473v-.059l.293-.058zm0 0"
        ></path>
        <path
          fill="#D9F3FC"
          d="M19.629 44.156c0 .18 0 .18-.063.301-.214.215-.527.238-.816.29.27-.235.57-.411.879-.59zm0 0"
        ></path>
        <path
          fill="#3573B7"
          d="M24.492 45.574c.313.074.547.184.82.352l.118.058v.118c.097.039.195.078.293.12-.059.028-.059.028-.118.06-.117-.055-.117-.055-.253-.137-.051-.028-.102-.06-.153-.086-.05-.032-.105-.063-.156-.094-.082-.047-.082-.047-.16-.094-.285-.168-.285-.168-.39-.238v-.059zm0 0"
        ></path>
        <path
          fill="#D8F4FC"
          d="M19.16 28.36c-.015.109-.015.109-.058.234-.11.078-.11.078-.235.117l-.176-.059v.118c-.175.117-.175.117-.304.097-.035-.012-.07-.027-.106-.039l.375-.234.106-.07c.27-.165.27-.165.398-.165zm0 0"
        ></path>
        <path
          fill="#D1F1FC"
          d="M13.652 51.41c.11.05.223.106.332.16l.188.094c.18.094.324.203.476.336a1.003 1.003 0 01-.585-.238 8.076 8.076 0 00-.41-.117v-.235zm0 0"
        ></path>
        <path
          fill="#3874B5"
          d="M10.02 29.535v.18c-.13.078-.262.152-.391.23l-.113.067c-.204.117-.371.203-.61.23.121-.129.242-.222.399-.308l.125-.07.133-.075.132-.074c.11-.059.215-.117.325-.18zm0 0"
        ></path>
        <path
          fill="#3A78BA"
          d="M22.852 28.477c.175.058.347.117.527.175v.118c.098.02.191.039.293.058v.117c.117.04.23.078.351.121l-.058.118-.524-.29-.152-.081c-.047-.028-.094-.051-.14-.079-.067-.035-.067-.035-.137-.074-.102-.066-.102-.066-.16-.183zm0 0"
        ></path>
        <path
          fill="#1F6EC3"
          d="M19.98 27.414c.434.059.434.059.645.117-.23.121-.453.219-.703.297l-.176.059v-.117c.059-.063.117-.122.176-.18l.058-.176zm0 0"
        ></path>
        <path
          fill="#3877BD"
          d="M11.074 49.875h.235v.117c.054.008.109.016.164.02.199.043.23.074.363.218.152.07.152.07.293.118l-.059.175c-.168-.093-.332-.191-.5-.289-.047-.027-.093-.054-.14-.086-.047-.023-.09-.05-.137-.078-.043-.023-.086-.05-.129-.074-.027-.02-.059-.039-.09-.062v-.059zm0 0"
        ></path>
        <path
          fill="#DEF5FC"
          d="M30.41 32.898c.086.043.168.086.254.133.047.024.094.047.14.074.141.09.216.184.31.32-.356-.01-.356-.01-.505-.136-.199-.238-.199-.238-.199-.39zm0 0"
        ></path>
        <path
          fill="#DAF4FC"
          d="M12.95 31.895c0 .175 0 .175-.083.277-.094.078-.094.078-.21.078l-.06.117a7.4 7.4 0 01-.41.059c.141-.16.297-.258.481-.364.05-.03.105-.062.16-.097.04-.024.078-.047.121-.07zm0 0"
        ></path>
        <path
          fill="#D6F1FB"
          d="M20.098 27.828v.117h-.118l-.058.176a6.178 6.178 0 01-.352.117c-.058.04-.117.078-.175.121-.13-.023-.13-.023-.235-.062.133-.078.27-.156.402-.235.04-.023.079-.042.118-.066.289-.168.289-.168.418-.168zm0 0"
        ></path>
        <path
          fill="#D2EFFB"
          d="M16.934 25.586c-.309.176-.618.352-.938.531l-.059-.176h.235v-.117h.176v-.12c.324-.184.324-.184.586-.118zm0 0"
        ></path>
        <path
          fill="#D7F2FC"
          d="M16.875 53.297c.465.23.465.23.938.469-.06.039-.118.078-.176.12a7.898 7.898 0 00-.25-.136 4.547 4.547 0 00-.14-.078 2.422 2.422 0 01-.372-.258v-.117zm0 0"
        ></path>
        <path
          fill="#437ABD"
          d="M7.441 47.578c.118 0 .118 0 .207.082.028.031.055.063.086.094l.118.059v.175l.171.055c.18.066.18.066.239.184a1.741 1.741 0 01-.82-.473v-.176zm0 0"
        ></path>
        <path
          fill="#D5F1FB"
          d="M13.242 33.781l-.433.262c-.059.039-.059.039-.121.074l-.122.074c-.035.02-.07.043-.109.067-.07.039-.14.078-.21.113l-.06-.176.122-.043c.183-.082.324-.183.48-.304.16-.106.277-.157.453-.067zm0 0"
        ></path>
        <path
          fill="#216FC3"
          d="M30.059 32.66h.234v.117c.137.02.27.04.41.063.02-.04.04-.078.059-.121l.175.058-.058.239c-.3-.059-.567-.106-.82-.297v-.059zm0 0"
        ></path>
        <path
          fill="#DAF4FD"
          d="M22.559 24.113c.043.02.09.035.136.055a4.8 4.8 0 00.332.121l.059.176.117.058c-.02.04-.039.079-.058.122-.23-.137-.465-.274-.704-.415l.118-.117zm0 0"
        ></path>
        <path
          fill="#3170B7"
          d="M6.973 46.691c.27.27.328.586.41.946-.16-.149-.266-.266-.336-.473-.016-.039-.031-.078-.043-.117-.031-.117-.031-.117-.031-.356zm0 0"
        ></path>
        <path
          fill="#DBF3FB"
          d="M24.844 45.809c.105.054.21.113.316.168.059.03.117.062.176.097.152.086.152.086.27.207a5.135 5.135 0 01-.762-.18v-.292zm0 0"
        ></path>
        <path
          fill="#2F73B5"
          d="M19.219 44.453c-.27.156-.543.309-.82.473v-.18h.117v-.117l.285-.121.16-.07c.14-.043.14-.043.258.015zm0 0"
        ></path>
        <path
          fill="#E6F6FB"
          d="M15.586 32.129c.059.02.117.039.176.062-.012.11-.012.11-.059.235a2.094 2.094 0 01-.527.176c.082-.204.152-.262.351-.352.02-.04.04-.078.059-.121zm0 0"
        ></path>
        <path
          fill="#1B6CC1"
          d="M7.5 31.07c0 .176 0 .176-.059.278-.082.187-.066.347-.058.547l-.293.058c.023-.101.047-.207.074-.308.012-.06.027-.114.04-.176.07-.184.151-.274.296-.399zm0 0"
        ></path>
        <path
          fill="#DCF2FB"
          d="M21.68 23.64l.41.06v.238h.234v.175a4.239 4.239 0 01-.703-.355l.059-.117zm0 0"
        ></path>
        <path
          fill="#D9F1FC"
          d="M12.54 50.762c.23.117.464.23.702.351-.246.125-.281.13-.527.059v-.176l-.176-.117v-.117zm0 0"
        ></path>
        <path
          fill="#D7F5FD"
          d="M22.148 28.121c.114.059.227.113.34.172.063.031.13.062.192.094.172.09.172.09.347.207l-.058.117c-.114-.055-.23-.106-.344-.16l-.195-.094c-.168-.102-.22-.152-.282-.336zm0 0"
        ></path>
        <path
          fill="#1F70C4"
          d="M24.492 25.586c.25-.02.371-.023.582.117l.121.121c-.261.028-.261.028-.527.059-.059-.098-.117-.195-.176-.297zm0 0"
        ></path>
        <path
          fill="#DDF4FC"
          d="M23.32 54.18c-.023.14-.023.14-.117.297-.191.062-.387.09-.586.117.496-.414.496-.414.703-.414zm0 0"
        ></path>
        <path
          fill="#E0F9FD"
          d="M7.266 47.578c.257.192.511.387.761.59-.316-.04-.55-.184-.754-.43l-.066-.101.059-.059zm0 0"
        ></path>
        <path
          fill="#2C71B6"
          d="M34.336 47.398l.176.059c-.192.254-.367.43-.645.59h-.117v-.117c.035-.016.07-.028.105-.043.141-.082.22-.16.32-.29.032-.035.06-.074.09-.113.024-.027.047-.054.07-.086zm0 0"
        ></path>
        <path
          fill="#2670BC"
          d="M19.395 40.324v.117c-.079.02-.157.04-.235.063-.02.094-.039.191-.058.293l-.293-.059a.61.61 0 01.586-.414zm0 0"
        ></path>
        <path
          fill="#DEF6FD"
          d="M15.176 32.66l-.285.18-.16.097c-.141.079-.141.079-.258.079v-.176c.214-.211.422-.274.703-.18zm0 0"
        ></path>
        <path
          fill="#D4F0FD"
          d="M25.898 30.305c.137.062.27.129.407.199.039.016.078.035.117.055.289.144.289.144.355.273-.199.023-.273.016-.441-.105-.047-.043-.094-.086-.145-.13l-.164-.093-.129-.082v-.117zm0 0"
        ></path>
        <path
          fill="#D5F5FC"
          d="M11.367 50.113c.293.102.555.258.82.41v.059c-.136.012-.136.012-.292 0-.086-.074-.086-.074-.176-.176a7.37 7.37 0 00-.352-.176v-.117zm0 0"
        ></path>
        <path
          fill="#D4F0FC"
          d="M9.668 49.11c.293.105.555.257.82.413l-.117.118c-.156-.078-.309-.157-.469-.235v-.12l-.234-.06v-.117zm0 0"
        ></path>
        <path
          fill="#226EC2"
          d="M14.824 45.926l.528.117.058.297c-.289-.074-.418-.164-.586-.414zm0 0"
        ></path>
        <path
          fill="#3570B2"
          d="M13.066 33.84v.176c-.148.109-.148.109-.343.222-.063.04-.13.075-.196.114-.054.027-.109.05-.164.078l-.117-.059a4.04 4.04 0 01.82-.531zm0 0"
        ></path>
        <path
          fill="#D9F3FD"
          d="M34.219 31.07c.168.016.234.059.363.176.14.234.152.442.164.707-.125-.187-.23-.383-.34-.578a3.972 3.972 0 00-.187-.305zm0 0"
        ></path>
        <path
          fill="#3374BB"
          d="M31.523 29.477l.282.136c.054.028.105.051.16.078.133.075.219.145.32.258-.137.012-.137.012-.293 0-.09-.086-.09-.086-.176-.176-.125-.043-.125-.043-.234-.058l-.059-.238zm0 0"
        ></path>
        <path
          fill="#3574BA"
          d="M22.793 54.477l-.703.41-.117-.117h.175v-.118h.176l.059-.175c.172-.07.226-.063.41 0zm0 0"
        ></path>
        <path
          fill="#DAF5FB"
          d="M26.836 52.059l.117.058v.117c-.426.27-.426.27-.703.235.188-.153.371-.301.586-.41zm0 0"
        ></path>
        <path
          fill="#DDF2FB"
          d="M27.422 45.75a.958.958 0 01-.176.41h-.117v-.117l-.293.059c.434-.352.434-.352.586-.352zm0 0"
        ></path>
        <path
          fill="#DAF3FB"
          d="M13.477 45.277c.23.118.464.235.703.356l-.117.117c-.258-.07-.415-.145-.586-.355v-.118zm0 0"
        ></path>
        <path
          fill="#2A73C2"
          d="M20.098 40.031c-.121.149-.121.149-.293.293-.223.02-.223.02-.41 0 .226-.238.37-.308.703-.293zm0 0"
        ></path>
        <path
          fill="#2F70B8"
          d="M8.79 30.242l.058.18c-.203.203-.485.246-.762.293.223-.188.45-.332.703-.473zm0 0"
        ></path>
        <path
          fill="#3874BA"
          d="M16.523 29.89c-.27.157-.543.313-.82.473-.02-.039-.039-.078-.058-.12.039-.005.074-.013.113-.016.039-.016.078-.028.12-.043l.06-.176c.105-.059.105-.059.23-.102.043-.015.082-.031.125-.047.113-.027.113-.027.23.032zm0 0"
        ></path>
        <path
          fill="#D5F1FC"
          d="M12.363 28.063l.176.058c-.348.203-.348.203-.703.414 0-.176 0-.176.059-.297.117-.039.234-.082.351-.117l.117-.058zm0 0"
        ></path>
        <path
          fill="#3274B7"
          d="M27.598 27.238c.312.086.554.235.82.41-.117.059-.117.059-.324.016-.203-.074-.203-.074-.32-.25l-.176-.059v-.117zm0 0"
        ></path>
        <path
          fill="#D3F0FA"
          d="M21.504 43.863c.25.137.504.274.762.41-.223.079-.297.032-.508-.054-.059-.02-.117-.043-.176-.067l-.137-.054.059-.235zm0 0"
        ></path>
        <path
          fill="#DFF7FD"
          d="M23.086 28.652c.21.118.426.235.644.356v.176c-.117-.059-.23-.118-.351-.176v-.121c-.098-.02-.192-.04-.293-.059v-.176zm0 0"
        ></path>
        <path
          fill="#D5F2FB"
          d="M25.488 25.941c.274.036.532.137.762.293l.059.176c-.293-.101-.555-.258-.82-.41v-.059zm0 0"
        ></path>
        <path
          fill="#3371B7"
          d="M31.7 49.168l.116.059c-.113.07-.23.14-.343.207-.063.039-.13.078-.196.117-.164.09-.164.09-.28.09v-.118c.218-.156.452-.261.702-.355zm0 0"
        ></path>
        <path
          fill="#DAF3FD"
          d="M16.23 46.223c-.058.175-.058.175-.25.273a1.01 1.01 0 01-.511.078v-.176c.031.016.058.028.09.043.277.028.406-.218.671-.218zm0 0"
        ></path>
        <path
          fill="#E0F6FA"
          d="M20.918 43.566c.203.075.36.16.527.297-.164.047-.261.07-.425.016-.102-.074-.102-.074-.16-.254.019-.02.038-.035.058-.059zm0 0"
        ></path>
        <path
          fill="#DEF6FE"
          d="M29.648 32.484c.23.118.465.235.704.356-.059.039-.118.074-.176.117v-.117h-.235v-.121l-.175.058c-.04-.093-.078-.191-.118-.293zm0 0"
        ></path>
        <path
          fill="#3574BB"
          d="M29.063 32.07c.136.04.269.078.41.121v.118c.097.02.191.039.293.058l.058.176a2.887 2.887 0 01-.762-.414v-.059zm0 0"
        ></path>
        <path
          fill="#E2F1F6"
          d="M13.496 31.676c.031.015.063.027.098.043v.234l-.235.059-.058-.235-.059.176-.176-.117c.258-.18.258-.18.43-.16zm0 0"
        ></path>
        <path
          fill="#2E6EBA"
          d="M26.836 26.766c.094.047.187.09.281.136.055.024.106.051.16.078.133.075.22.145.32.258h-.234v-.117c-.136-.02-.27-.039-.41-.062v-.176h-.117v-.117zm0 0"
        ></path>
        <path
          fill="#DFF5FC"
          d="M19.219 24.172a1.54 1.54 0 01-.469.351.82.82 0 01-.117-.058c.14-.309.258-.3.586-.293zm0 0"
        ></path>
        <path
          fill="#2F71B8"
          d="M26.016 52.59l-.286.176-.16.097c-.14.078-.14.078-.258.078v-.117l.235-.058v-.118c.336-.125.336-.125.469-.058zm0 0"
        ></path>
        <path
          fill="#3371B7"
          d="M14.063 47.637c.292.101.554.258.82.41-.11.035-.11.035-.235.062-.109-.074-.109-.074-.234-.18-.117-.058-.234-.12-.351-.175v-.117zm0 0"
        ></path>
        <path
          fill="#D0ECFA"
          d="M12.715 46.809l.223.023c.062.008.062.008.124.012.122.027.122.027.297.144l-.058.176a40.944 40.944 0 00-.586-.293v-.062zm0 0"
        ></path>
        <path
          fill="#3374B9"
          d="M16.113 46.281c-.261.176-.261.176-.41.235-.172-.043-.172-.043-.293-.118.242-.136.434-.207.703-.117zm0 0"
        ></path>
        <path
          fill="#DBF1FB"
          d="M14.883 46.102c.203.074.36.16.527.296l-.176.059-.117-.059v.118H15a1.047 1.047 0 00-.027-.106 2.792 2.792 0 00-.09-.308zm0 0"
        ></path>
        <path
          fill="#DCF6FD"
          d="M17.93 40.973l.117.117-.645.355-.058-.175.351-.06c.02-.058.04-.116.059-.179l.176-.058zm0 0"
        ></path>
        <path
          fill="#2970C5"
          d="M15.176 32.66c.02.059.039.117.058.18-.07.086-.07.086-.175.176-.157.011-.157.011-.293 0 .086-.203.168-.356.41-.356zm0 0"
        ></path>
        <path
          fill="#D4EEFB"
          d="M17.754 29.125c0 .176 0 .176-.059.293a6.177 6.177 0 01-.351.117l-.117-.117c.175-.098.347-.195.527-.293zm0 0"
        ></path>
        <path
          fill="#D5F1FC"
          d="M14.004 27.059h.293c-.223.199-.43.304-.703.414l.058-.176h.118v-.117h.234v-.121zm0 0"
        ></path>
        <path
          fill="#D1EEFC"
          d="M24.55 25.234l.118.059v.117l.14.055c.153.062.153.062.27.12v.118a3.94 3.94 0 01-.703-.351l.176-.118zm0 0"
        ></path>
        <path
          fill="#2C72B8"
          d="M25.078 52.941l.235.059-.286.176-.16.101c-.14.078-.14.078-.258.078.02-.058.04-.117.059-.18.207-.066.207-.066.41-.116v-.118zm0 0"
        ></path>
        <path
          fill="#CEEFFB"
          d="M25.43 52.883l.117.058-.176.059-.058.176c-.106.074-.106.074-.235.12-.125-.026-.125-.026-.234-.058.093-.062.191-.12.285-.183.055-.032.105-.067.16-.102l.14-.07zm0 0"
        ></path>
        <path
          fill="#3677B7"
          d="M16.934 45.75a3.726 3.726 0 01-.512.336c-.07.039-.07.039-.145.078-.035.02-.07.035-.105.059l.058-.18c.122-.04.122-.04.235-.059v-.117c.187-.125.25-.129.469-.117zm0 0"
        ></path>
        <path
          fill="#D6F3FB"
          d="M28.125 45.453c-.105.137-.184.227-.355.266-.114.015-.23.023-.348.031.453-.379.453-.379.703-.297zm0 0"
        ></path>
        <path
          fill="#D6F0FC"
          d="M18.75 44.746v.117c-.094.078-.094.078-.219.16-.043.028-.082.055-.125.082-.148.063-.21.051-.36-.003l.286-.176c.078-.051.078-.051.16-.102.14-.078.14-.078.258-.078zm0 0"
        ></path>
        <path
          fill="#D3F0FC"
          d="M14.004 33.309c-.215.18-.453.293-.703.414v-.176h.234v-.121c.188-.125.25-.13.469-.117zm0 0"
        ></path>
        <path
          fill="#3673BA"
          d="M30.469 32.898l.258.082.144.051c.125.043.125.043.242.102l-.058.234-.13-.105c-.16-.13-.16-.13-.327-.227a2.267 2.267 0 00-.13-.078v-.059zm0 0"
        ></path>
        <path
          fill="#D6F0F9"
          d="M8.145 30.363h.468c-.187.16-.351.274-.586.352l.118-.352zm0 0"
        ></path>
        <path
          fill="#306FB9"
          d="M15 26.707c-.059.145-.098.223-.227.313-.148.046-.214.023-.359-.02l.227-.145c.043-.027.086-.054.129-.085.113-.063.113-.063.23-.063zm0 0"
        ></path>
        <path
          fill="#1869CA"
          d="M19.512 24.113l.117.059c-.078.09-.078.09-.176.176h-.176v.117l-.351.058c.176-.195.344-.308.586-.41zm0 0"
        ></path>
        <path
          fill="#2A6EBB"
          d="M19.453 54.71c.176.036.352.071.527.118l.06.234c-.259-.07-.411-.148-.587-.351zm0 0"
        ></path>
        <path
          fill="#DEF4FC"
          d="M16.934 45.809c-.067.203-.114.25-.293.351-.133-.015-.133-.015-.235-.058.36-.293.36-.293.528-.293zm0 0"
        ></path>
        <path
          fill="#3877B8"
          d="M30.879 45.691v.176l-.586.293c.07-.215.129-.23.324-.332.051-.027.098-.055.149-.078.039-.02.074-.04.113-.059zm0 0"
        ></path>
        <path
          fill="#3976BA"
          d="M27.07 32.957c.25.137.504.27.762.41l-.234.059c-.114-.07-.114-.07-.235-.176l-.16-.09c-.043-.031-.09-.058-.133-.086v-.117zm0 0"
        ></path>
        <path
          fill="#196AC3"
          d="M10.547 29.3h.117v.177l-.41.058v.121l-.234.059c.03-.117.03-.117.117-.238.21-.043.21-.043.41-.059v-.117zm0 0"
        ></path>
        <path
          fill="#DEF3FA"
          d="M16.992 25.176c.117.035.23.074.352.117-.278.234-.278.234-.41.234a3.664 3.664 0 010-.293l.058-.058zm0 0"
        ></path>
        <path
          fill="#DAF4FC"
          d="M22.266 50.703c-.301.258-.301.258-.528.293v-.176c.203-.136.293-.129.528-.117zm0 0"
        ></path>
        <path
          fill="#2575C1"
          d="M31.934 48.816h.293c-.012.11-.012.11-.059.235-.148.074-.148.074-.293.117l.059-.352zm0 0"
        ></path>
        <path
          fill="#256DB6"
          d="M15.645 48.578c.265.074.437.172.644.356-.137-.02-.27-.04-.41-.059v-.117a9.95 9.95 0 01-.293-.063c.02-.039.039-.074.059-.117zm0 0"
        ></path>
        <path
          fill="#D5EEFB"
          d="M33.281 48.402v.118c-.074.039-.148.078-.222.113l-.125.066c-.121.059-.121.059-.297.117v-.12c.086-.048.172-.098.258-.145l.144-.086c.125-.063.125-.063.242-.063zm0 0"
        ></path>
        <path
          fill="#D3EEF9"
          d="M6.973 46.93c.293.441.293.441.293.648l-.235-.058-.058-.59zm0 0"
        ></path>
        <path
          fill="#DDF3FB"
          d="M34.805 46.223h.058l.012.343c.004.098.004.098.004.196-.004.054-.012.11-.016.168l-.175.117c.03-.277.07-.55.117-.824zm0 0"
        ></path>
        <path
          fill="#D7F2FC"
          d="M26.836 46.102c-.02.058-.04.117-.059.18l-.175.058-.059.117h-.352c.454-.355.454-.355.645-.355zm0 0"
        ></path>
        <path
          fill="#2F73B9"
          d="M7.969 30.715l.176.058c-.04.016-.075.032-.114.051-.14.063-.14.063-.18.246l-.175.059-.117-.117c.062-.051.128-.102.195-.153l.11-.086c.034-.02.07-.039.105-.058zm0 0"
        ></path>
        <path
          fill="#DEF5FD"
          d="M11.602 28.652l-.223.153c-.063.039-.063.039-.125.082-.121.058-.121.058-.297 0 .121-.242.402-.317.645-.235zm0 0"
        ></path>
        <path
          fill="#D8F2FC"
          d="M15.645 52.59c.203.07.359.156.527.293l-.176.117c-.016-.035-.027-.074-.043-.113-.062-.133-.062-.133-.2-.164l-.108-.016v-.117zm0 0"
        ></path>
        <path
          fill="#2B6EB0"
          d="M14.18 51.645c.144.03.144.03.293.058v.117c.097.02.191.04.293.059V52c-.258-.074-.41-.148-.586-.355zm0 0"
        ></path>
        <path
          fill="#CAECFA"
          d="M27.598 47.52l.117.058c-.29.176-.29.176-.586.352v-.176c.074-.043.152-.082.226-.121l.13-.07c.035-.016.074-.028.113-.043zm0 0"
        ></path>
        <path
          fill="#D5F2FC"
          d="M12.95 44.984c.202.07.359.157.527.293-.176.059-.176.059-.364-.027a3.405 3.405 0 01-.164-.09v-.176zm0 0"
        ></path>
        <path
          fill="#1870CB"
          d="M18.371 44.684c.074.004.074.004.145.004-.075.148-.075.148-.176.296h-.235c.067-.297.067-.297.266-.3zm0 0"
        ></path>
        <path
          fill="#2F72BA"
          d="M19.863 44.098c-.289.148-.289.148-.586.297l.118-.297c.19-.07.273-.067.468 0zm0 0"
        ></path>
        <path
          fill="#CEF3FC"
          d="M15.645 42.152h.468c-.136.16-.27.227-.468.297v-.297zm0 0"
        ></path>
        <path
          fill="#266DB8"
          d="M27.012 30.89h.41c.039.079.078.157.117.239-.324-.035-.324-.035-.46-.152-.024-.028-.044-.055-.067-.086zm0 0"
        ></path>
        <path
          fill="#CCE9F9"
          d="M33.281 30.48c.407.055.407.055.586.176l.059.176a1.471 1.471 0 01-.645-.352zm0 0"
        ></path>
        <path
          fill="#DEF6FC"
          d="M18.281 28.887c-.082.187-.117.238-.293.355l-.117-.058c.059-.176.059-.176.172-.247.121-.05.121-.05.238-.05zm0 0"
        ></path>
        <path
          fill="#D4F1FB"
          d="M30.586 28.887c.16.031.312.066.469.12v.118h.117v.117a2.754 2.754 0 01-.586-.297v-.058zm0 0"
        ></path>
        <path
          fill="#136EC5"
          d="M22.91 24.586l.176.059h-.176v-.06zm0 .059v.234c-.098-.02-.191-.04-.293-.059v-.117c.117-.058.117-.058.293-.058zm0 0"
        ></path>
        <path
          fill="#CBEAF8"
          d="M19.805 55.004l.148.055c.203.066.406.125.613.183v.059c-.304.023-.492-.047-.761-.176v-.121zm0 0"
        ></path>
        <path
          fill="#246EC7"
          d="M18.926 50.523l.586.239v.175l-.176-.058v-.117c-.07-.016-.07-.016-.14-.028-.153-.03-.153-.03-.27-.093v-.118zm0 0"
        ></path>
        <path
          fill="#DBF4FD"
          d="M32.05 49.05l.118.06c-.195.234-.195.234-.395.25-.043-.005-.09-.008-.132-.016.277-.227.277-.227.41-.293zm0 0"
        ></path>
        <path
          fill="#D0EEFB"
          d="M9.727 29.773l-.586.293v-.175h.234v-.118c.117-.058.117-.058.352 0zm0 0"
        ></path>
        <path
          fill="#DAF3FC"
          d="M22.207 54.77l.059.175c-.118.059-.23.117-.352.18a3.485 3.485 0 01-.117-.121c.137-.078.27-.156.41-.234zm0 0"
        ></path>
        <path
          fill="#E3F5FC"
          d="M28.477 51.172c-.075.223-.157.25-.352.355.02-.109.02-.109.059-.234.175-.121.175-.121.293-.121zm-.528.355l.176.059-.176.059v-.118zm0 0"
        ></path>
        <path
          fill="#206EBE"
          d="M32.871 48.344c.098.02.191.039.293.058-.2.188-.379.211-.644.235l.058-.117h.234l.06-.176zm0 0"
        ></path>
        <path
          fill="#D1EDFA"
          d="M14.18 47.637c.086.023.172.05.261.078l.145.043c.039.015.078.035.121.054l.059.176a2.74 2.74 0 01-.586-.293v-.058zm0 0"
        ></path>
        <path
          fill="#3470BC"
          d="M13.477 47.34c.257.031.394.125.585.297-.16.015-.16.015-.351 0-.14-.149-.14-.149-.234-.297zm0 0"
        ></path>
        <path
          fill="#D6F3FC"
          d="M14.238 45.75c.223.086.434.184.645.293-.176.059-.176.059-.297.016-.04-.024-.082-.047-.125-.07l-.125-.067c-.031-.02-.066-.035-.098-.055v-.117zm0 0"
        ></path>
        <path
          fill="#D2F1FC"
          d="M24.023 45.336l.528.297c-.184.058-.238.078-.41 0-.075-.153-.075-.153-.118-.297zm0 0M29.063 32.129l.585.297c-.234.058-.234.058-.425-.047a5.753 5.753 0 00-.16-.129v-.121zm0 0"
        ></path>
        <path
          fill="#DDF3FB"
          d="M13.066 27.828c-.394.235-.394.235-.527.235l.059-.235c.191-.047.277-.066.468 0zm0 0"
        ></path>
        <path
          fill="#E2F7FD"
          d="M13.652 51.41l.41.235v.058l-.41-.058v-.235zm0 0"
        ></path>
        <path
          fill="#D7F1FC"
          d="M15.293 48.285c.137.02.27.04.41.059l.059.234c-.157-.078-.309-.156-.469-.234v-.059zm0 0"
        ></path>
        <path
          fill="#D6F1FD"
          d="M29.355 46.633c-.289.148-.289.148-.585.297.058-.18.058-.18.195-.282.156-.074.156-.074.39-.015zm0 0"
        ></path>
        <path
          fill="#3E79B9"
          d="M22.676 44.512c.086.023.172.05.262.078l.144.043c.04.02.078.035.121.054l.059.176a2.74 2.74 0 01-.586-.293v-.058zm0 0"
        ></path>
        <path
          fill="#D4F1FC"
          d="M23.262 40.797c.16.031.312.066.468.117v.176c-.199-.067-.332-.133-.468-.293zm0 0"
        ></path>
        <path
          fill="#3975B7"
          d="M7.207 31.363c.059.18.059.18-.02.39-.097.2-.097.2-.214.259.027-.086.054-.172.086-.258l.046-.145c.043-.129.043-.129.102-.246zm0 0"
        ></path>
        <path
          fill="#D7F2FC"
          d="M24.96 29.773c.278.11.278.11.411.176v.117c-.176-.027-.176-.027-.351-.058l-.06-.235zm0 0"
        ></path>
        <path
          fill="#D4F1FC"
          d="M24.727 53.297l.117.058c-.117.06-.117.06-.235.118v.117l-.175.058-.118-.117c.309-.191.309-.191.41-.234zm0 0"
        ></path>
        <path
          fill="#3878C1"
          d="M16.875 53.238c.395.11.395.11.527.176v.117c-.222-.062-.379-.113-.527-.293zm0 0"
        ></path>
        <path
          fill="#CEECF9"
          d="M24.61 49.406c-.395.235-.395.235-.528.235v-.176c.328-.125.328-.125.527-.059zm0 0"
        ></path>
        <path
          fill="#2A70B9"
          d="M7.441 47.578c.118 0 .118 0 .207.078.028.035.055.067.086.098l.118.117c-.137.016-.137.016-.293 0-.106-.117-.106-.117-.176-.234l.058-.059zm0 0"
        ></path>
        <path
          fill="#DAF4FA"
          d="M25.605 46.281c.172.063.282.102.41.235-.144.074-.199.047-.35 0v-.118l-.118-.058.058-.059zm0 0"
        ></path>
        <path
          fill="#3B7ABC"
          d="M22.383 40.324l.586.297c-.235.059-.235.059-.426-.05a3.872 3.872 0 01-.16-.13v-.117zm0 0"
        ></path>
        <path
          fill="#2170C5"
          d="M29.883 32.191c.039.036.078.075.117.118h-.117v-.118zm-.059.118l.176.117-.059.117.118.059-.118.058-.175-.176.058-.175zm0 0"
        ></path>
        <path
          fill="#DDF4FD"
          d="M32.813 30.184c.265-.02.265-.02.398.09.023.027.047.058.07.09l-.058.116-.41-.238v-.058zm0 0"
        ></path>
        <path
          fill="#1A6AD0"
          d="M25.488 26.059c.23.117.23.117.469.234v.059c-.137-.02-.27-.04-.41-.059l-.059-.234zm0 0"
        ></path>
        <path
          fill="#D6F0FB"
          d="M17.668 24.992c.074.004.074.004.145.004-.125.14-.243.219-.41.297.066-.293.066-.293.265-.3zm0 0"
        ></path>
        <path
          fill="#D0EDF9"
          d="M18.574 24.645c-.394.234-.394.234-.527.234.043-.113.043-.113.117-.234.172-.075.227-.063.41 0zm0 0"
        ></path>
      </g>
    </svg>
  );
}

const MemoNoData = React.memo(WealthboxIcon);
export default MemoNoData;
